"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            BoundaryError: "Some of the information that you entered is not valid. You must enter valid information before you can continue.",
            FactBoxPane_Close: "Close the Related Information pane",
            FactBoxPane_Next: "Move to the next FactBox",
            FactBoxPane_nthFactBox: "Move to the nth FactBox",
            FactBoxPane_Prev: "Move to the previous FactBox",
            FactBoxPane_ToggleHelpText: "(Ctrl+F2)",
            FactBoxPane_ToggleToolTip: "Toggle Related Information pane",
            Form_AttachDocument: "Attach a document",
            Form_Close: "Close the form",
            Form_DefaultAction: "Execute default action",
            Form_DeleteRecord: "Delete record",
            Form_DetailsView: "Switch to details view",
            Form_DoYouWantToLeave: "Are you sure you want to leave this page?",
            Form_DoYouWantToSave: "Do you want to save your changes before closing?",
            Form_EditMode: "Edit mode",
            Form_ExportExcel: "Export to Excel",
            Form_FirstRecord: "Move to the first record",
            Form_ForceClose: "Close the form discarding any unsaved changes",
            Form_GoToActionPane: "Go to action pane",
            Form_GoToActionSearch: "Go to action search",
            Form_GoToFactBoxPane: "Go to Related Information pane",
            Form_GoToFilterPane: "Go to filter pane",
            Form_GoToFirstVisible: "Move to the first visible field on the form",
            Form_GoToMessageBar: "Go to the message bar",
            Form_GoToNavList: "Go to the navigation list",
            Form_GoToNavSearch: "Go to navigation search",
            Form_GridView: "Switch to grid view",
            Form_HeaderView: "Switch to header view",
            Form_LastRecord: "Move to the last record",
            Form_LinesView: "Switch to lines view",
            Form_LookupForm: "Lookup form",
            Form_NewRecord: "Create a new record",
            Form_NextRecord: "Move to the next record",
            Form_OpenAdvancedSort: "Open advanced filtering and sorting",
            Form_Personalize: "Personalize this page",
            Form_PrevRecord: "Move to the previous record",
            Form_ReactGridUnsupported: "An unsupported scenario was detected with the New grid control feature. Please refresh to use the existing grid for this page.",
            Form_Refresh: "Data Refresh",
            Form_RegionTitle: "Form Region",
            Form_RequestClose: "Close the form with explicit save",
            Form_Revert: "Revert any changes",
            Form_SaveRecord: "Save record",
            Form_SelectAll: "Select or clear all rows",
            Form_ViewMode: "View mode",
            LostConnectionDialog_Message: "It appears you lost network connectivity.",
            LostConnectionDialog_RetryButtonText: "Reconnect",
            ProgressMessage_CancelText: "Stop",
            ProgressMessage_Text: "We're working on it. This may take a while.",
            SidePanel_Close: "Close the side panel",
            SidePanel_RegionTitle: "Side Panel Region",
        },
    });
    $dyn.ui.defaults.Form = {
        ActiveControl: null,
        AddInfoStep: function () { },
        AllowExplicitPersonalization: true,
        AllowPersonalization: false,
        AllowRootNavigation: false,
        ApplyViewForFormPart: function (hostkey) { },
        ArrangeMethod: $dyn.layout.ArrangeMethod.vertical,
        CanSwitchViewMode: false,
        Caption: "",
        Columns: "1",
        CurrentViewKey: "",
        DefaultAction: null,
        DefaultActionEnabled: false,
        DialogSize: $dyn.ui.DialogSize.small,
        DisplayTarget: 0,
        ExecuteActionSearch: null,
        ExecuteActionSearchClick: null,
        ExecutePersonalizationCommand: function () { },
        ExecuteShortcuts: null,
        FactBoxPaneInitiallyExpanded: false,
        Filter: function (filterValue) { },
        FilterPane: null,
        FormCompany: "",
        FormCompanyName: "",
        FormSetDefaultCompany: false,
        GlobalStyle: {},
        Height: $dyn.layout.Size.available,
        IsActive: false,
        IsFormReady: false,
        IsInViewMode: false,
        LinkedViewDirty: function () { },
        MenuItemName: "",
        OnSelectControlEnabled: false,
        OpenGridView: function () { },
        Parameters: "",
        ParentTitleFields: "" /* The parent record context, records which record this form was opened from */,
        PersistFormPartViewChanges: function (hostkey) { },
        PersistMultiplePersonalization: function (serializedString) { },
        PersistPersonalization: function () { },
        PersonalizationData: "",
        PersonalizationViewsSaveModel: 0,
        // Shell has behaviors to automatically close forms under certain navigation actions, this helps keeping resources in check.
        // A form should not normally prevent auto-close unless it acts like a singleton and its owner has a way of reusing it
        PreventAutoClose: false,
        Recordable: false,
        Refresh: function (recordable) { },
        RequestClose: function () { },
        RequestCloseCancel: function () { },
        Save: function () { },
        SaveLinkedViews: 0,
        SetServerSelectedControl: function (evt) {
            var controlName = evt[0];
            this.ActiveControl(controlName);
        },
        ShowLinkToGridView: false,
        Style: "",
        TriggerLocalRefresh: false,
        UnsavedViewChanges: 0,
        UpdateLastSelectedControl: null,
        UpdatePersonalizationData: function () { },
        UpdateRecordContext: function () { },
        Width: $dyn.layout.Size.available,
    };
    // tslint:disable:object-literal-sort-keys
    var controls;
    (function (controls) {
        /**
         * Framework base class for Form controls
         *
         * @internal
         * @remarks Form lifecycle:
         * - Create
         * - Open/IsOpen
         * - Activate/IsActive
         * - Deactivate
         * - Close
         * - Dispose
         *
         *  Create:
         *  - Call Shell.createForm (formElement.dynReadyState is: uninitialized)
         *  - Databind form (owned by shell)
         *  - Pre-load form request (formElement.dynReadyState is: preloadRequest)
         *  - Pre-load form (formElement.dynReadyState is: preloading)
         *  - Request for form content (optional, formElement.dynReadyState is: request)
         *  - Populate with content (can happen before or after data bind, formElement.dynReadyState is: loading)
         *  - Done loading content: (formElement.dynReadyState is: ready)
         *
         *  Open:
         *  - Form.Open is called
         *  - IsOpen if set to true
         *
         *  Activation:
         *  - Shell.activateElement is called
         *  - Activate dialogs before activating the primary form, shell dialogs have first priority.
         *  - Dialogs that are closing are removed from the dialog stack, then detached
         *  - Form.IsActive = true
         *  - For dialogs, if closing, then Dialog._close is called (see Closing forms)
         *  - Shell.resetShellOnNavigation if called
         *
         *  Deactivation: (form is no longer at the top of the a navigation stack or is closed)
         *  - Shell.navigate or Shell.dialog is called on another form element
         *  - hide the element - unless doNotHide is set
         *  - If we are deactivating a form with an active slider, we need to deactivate the sliders.
         *  - Foreach dialog: deactivate it, hide it
         *  - Form.IsActive = false
         *
         *  Closure:
         *  - Form.Close is called (examples: by history, going back, open form close, or programatically)
         *  - Control.updateValue is called
         *  - if not popup,  AllowSave is called
         *  - Form.RequestClose is called
         *      - for server form interaction channel calls shell.close when server returns (or if client form calls shell.close in RequestClose)
         *          - previews are removed
         *          - form is removed by the shell (removePrimaryForm, dialogBack,removeFromAside ...)
         *              - form element is detached ...
         *          - dynReadyState is set to closed
         *          - Form._close is called
         *
         *  -- Event is raised that each PartControl has subscribed to.
         *  -- Each PartControl will in turn call close on its nested PartForm
         *  --- if !Form.disposeOnClose then the form is disposed/unbound
         *  --- See Deactivation section
         *  --- Third, figure out where to go next
         *  - Form.Close callback is called (used by popups)
         *
         *  - if Dialog - Shell.dialogBack
         *  -- If the dialog if not at the top of the stack, then mark it as closing
         *  -- The top of the stack is often a message box that is opened *before* the dialog is now being closed.
         *  -- This is done so that contextual information is still on the screen behind the message box.
         *  -- Else detach, deactivate, unbind, and
         *  -- If at not the bottom of dialog stack, then activate next dialog, else active the current of nav stack - See activation.
         *  -- In dialog binding handler, remove registration
         */
        var Form = /** @class */ (function (_super) {
            __extends(Form, _super);
            function Form(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                $dyn.ui.makeRoot(_this);
                _this.Loading = $dyn.observable();
                _this.Refreshing = $dyn.observable(false);
                _this.Processing = $dyn.observable();
                _this.ActiveElement = $dyn.observable();
                _this.LayoutWidth = $dyn.ui.autoProperty($dyn.layout.Size.available, _this, "Width");
                _this.LayoutHeight = $dyn.ui.autoProperty($dyn.layout.Size.available, _this, "Height");
                _this.Loaded = $dyn.observable();
                _this.dialogStack = $dyn.observableArray([]); // for form modal dialogs
                _this.invalidControls = {};
                _this.invalidUnboundControls = {};
                _this.IsOpen = $dyn.observable(false);
                _this._takeFocus = true;
                _this._formParts = [];
                _this.controlsWithAsyncRender = {};
                _this.waitForAsyncRender = $dyn.observable(false);
                // Function for finding the jquery object to transfer focus to
                _this.FindFocusTarget = undefined;
                _this.serializeTransitState = new $dyn.eventHost();
                _this.onClose = new $dyn.eventHost();
                _this.FactBoxPaneCollapsed = $dyn.observable(true);
                _this.FactBoxPaneImageName = $dyn.observable("OpenPane");
                _this.FactBoxPaneTooltip = $dyn.observable($dyn.label("FactBoxPane_ToggleToolTip"));
                _this.FactBoxPaneHelpText = $dyn.observable($dyn.label("FactBoxPane_ToggleHelpText"));
                _this.NoShowableFactBoxes = $dyn.observable(true);
                _this.DelayedFactBoxLoad = false;
                _this._zoomElementsMoved = false;
                _this.ObserveFactBoxes();
                $dyn.ui.applyDefaults(_this, data, $dyn.ui.defaults.Form);
                if ($dyn.ui.PerformanceTimer) {
                    $dyn.ui.PerformanceTimer.openedForm = true;
                }
                _this.LayoutArrangeMethod = _this.ArrangeMethod;
                _this.LayoutColumns = $dyn.ui.columnsProperty($dyn.layout.Columns.balanced, _this);
                _this.isRootFormActive = $dyn.computed(function () {
                    return $dyn.value(_this.IsActive);
                });
                _this.Close = $dyn.observable(function (options) {
                    var activeContext = $dyn.context($dyn.value(_this.ActiveElement));
                    if (activeContext && activeContext.updateValue) {
                        activeContext.updateValue(true);
                    }
                    var executeClose = function () {
                        if (options && typeof $dyn.value(options.closeCallback) === "function") {
                            _this.closeCallback = options.closeCallback;
                        }
                        else if (_this.closeCallback) {
                            // If no new closeCallback is provided we need to reset any existing this.closeCallback
                            _this.closeCallback = undefined;
                        }
                        var requestCloseCallback = function (success) {
                            if (!success) {
                                _this._isCloseRequested = false;
                                $dyn.log.navigation && $dyn.log.navigation("Navigation: form.RequestClose returned without success.");
                                $dyn.shell.browserHistory.failedClose();
                            }
                            _this.IsOpen(false);
                        };
                        // Close any dialogs before closing the primary form
                        var readyToClose = true;
                        for (var i = $dyn.length(_this.dialogStack) - 1; i >= 0; i--) {
                            var dialog = $dyn.context($dyn.value(_this.dialogStack)[i]);
                            if (dialog) {
                                readyToClose = false;
                                $dyn.log.navigation && $dyn.log.navigation("Navigation: close dialog before closing primary form: " + $dyn.value(dialog.FormName));
                                var dialogCloseCallback = function () {
                                    // Need a $dyn.async so the closing of the dialog is finished before calling RequestClose on the primary form
                                    $dyn.async(function () {
                                        // Now remove it from the cached root form object
                                        _this.dialogStack.pop();
                                        executeClose();
                                    }, undefined, "Calling execute close in callback to close the next form or dialog");
                                };
                                $dyn.callFunction(dialog.Close, undefined, { closeCallback: dialogCloseCallback });
                                break;
                            }
                            else {
                                // This part should not execute but even if it does we should remove from stack as it is a dialog with no context
                                _this.dialogStack.pop();
                            }
                        }
                        if (readyToClose) {
                            $(_this.element).trigger("formClose");
                            if (options && options.hasOwnProperty("record")) {
                                _this.callRequestClose(requestCloseCallback, options.record);
                            }
                            else {
                                _this.callRequestClose(requestCloseCallback);
                            }
                        }
                    };
                    if (_this._alwaysAllowClose) {
                        executeClose();
                    }
                    else {
                        // If the form does not always allow closing or AllowSave is failed (due to invalid controls) do not send a server request to close the current form.
                        _this.AllowSave(executeClose, function () {
                            $dyn.shell.browserHistory.failedClose();
                        });
                    }
                });
                if ($dyn.value(_this.RequestClose) === $dyn.ui.defaults.Form.RequestClose) {
                    _this.RequestClose(function () {
                        $dyn.shell.close({ form: _this });
                    });
                }
                var tabbingHandlerDispose;
                var tabContainer;
                $dyn.observe(_this.IsActive, function (isActive) {
                    if (isActive) {
                        if ($dyn.shell.isShellInitializing()) {
                            var subscriberId_1 = $dyn.shell.isShellInitializing.valueChanged.subscribe(function () {
                                if (!$dyn.shell.isShellInitializing()) {
                                    $dyn.layout.arrange(element, true);
                                    $dyn.shell.isShellInitializing.valueChanged.unsubscribe(subscriberId_1);
                                }
                            });
                        }
                        else {
                            $dyn.layout.arrange(element, true);
                        }
                        // By default all forms treat themselves as tabbing containers. This property is overridable in the prototype.
                        if (_this.IsTabbingContainer) {
                            tabContainer = $(element).find(".rootContent")[0] || element;
                            var noAriaLive = _this instanceof $dyn.controls.Dialog || _this instanceof $dyn.controls.Popup || _this instanceof $dyn.controls.Form;
                            tabbingHandlerDispose = $dyn.util.tabbingContainer(tabContainer, $dyn.label("Form_RegionTitle"), noAriaLive);
                        }
                        // adjust form headning levels if needed
                        _this.updateFormHeadingLevel();
                        // adjust if in zoom mode
                        _this._formZoomModeWidthObserver = $dyn.observe($dyn.shell.zoomModeWidth, function (inZoom) {
                            if ($dyn.value(_this.Style) !== "Dashboard" && $dyn.value(_this.Style) !== "Workspace" && _this.TypeName !== "Dialog") {
                                // check if form elements need to move into the app bar
                                _this._adjustBodyElementsForZoom(inZoom);
                            }
                        });
                        _this._formZoomModeHeightObserver = $dyn.observe($dyn.shell.zoomModeHeight, function (inZoom) {
                            if ($dyn.value(_this.Style) !== "Dashboard" && $dyn.value(_this.Style) !== "Workspace" && _this.TypeName !== "Dialog") {
                                if (inZoom && $dyn.value(_this.LayoutHeight) === $dyn.layout.Size.available) {
                                    _this.dynLayoutHeight = $dyn.value(_this.LayoutHeight);
                                    $dyn.setValue(_this, "LayoutHeight", $dyn.layout.Size.content);
                                    $dyn.layout.arrange(_this.element, true);
                                }
                                else if (!inZoom && $dyn.value(_this.LayoutHeight) === $dyn.layout.Size.content && _this.dynLayoutHeight === $dyn.layout.Size.available) {
                                    $dyn.setValue(_this, "LayoutHeight", _this.dynLayoutHeight);
                                    // clear out old
                                    _this.dynLayoutHeight = undefined;
                                    $dyn.layout.arrange(_this.element, true);
                                }
                            }
                        });
                    }
                    else {
                        // isActive == false
                        if (tabbingHandlerDispose) {
                            tabbingHandlerDispose();
                            tabbingHandlerDispose = undefined;
                            tabContainer = undefined;
                        }
                        if (_this._formZoomModeWidthObserver) {
                            _this._formZoomModeWidthObserver.dispose();
                        }
                        if (_this._formZoomModeHeightObserver) {
                            _this._formZoomModeHeightObserver.dispose();
                        }
                    }
                });
                $dyn.observe(_this.ShowLinkToGridView, function (value) {
                    var captionElement = $(element).find(".formCaption");
                    if (value) {
                        $(captionElement).addClass("link-content-validLink");
                        $(captionElement).attr("role", "link");
                        $(captionElement).attr("tabindex", "0");
                    }
                    else {
                        $(captionElement).removeClass("link-content-validLink");
                        $(captionElement).removeAttr("role");
                        $(captionElement).attr("tabindex", $dyn.util.isEnhancedTabSequenceEnabled() ? "0" : "-1");
                    }
                });
                $dyn.observe(_this.ActiveControl, function (name) {
                    if (name) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->ActiveControl observer fired call setControlFocus control name %s", _this.Id, name);
                        if (!_this.ActiveBoundaryInfo) {
                            // Give an initial value to ActiveBoundaryInfo
                            var control = $dyn.context(_this.findControl(name));
                            if (control) {
                                _this.ActiveBoundaryInfo = { DataSource: control.DataSource, ServiceBoundary: control.ServiceBoundary };
                            }
                        }
                        // Check if the form is active before we set focus to the active control.
                        if (_this.isFormActive() && _this.isInActiveFocusRegion()) {
                            _this.setControlFocus(name);
                        }
                    }
                    else {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->ActiveControl observer fired call with no control name no-op", _this.Id);
                    }
                });
                if ($dyn.isObservable(_this.TriggerLocalRefresh)) {
                    _this.TriggerLocalRefresh.valueChanged.subscribe(_this.LocalRefresh.bind(_this));
                }
                _this.FormCaption = $dyn.computed(function () {
                    if ($dyn.restrictedNavigation && $dyn.value(_this.FormCompany)) {
                        var formCompany = $dyn.value(_this.FormCompany).toUpperCase();
                        return $dyn.format("{0} - {1}", $dyn.value(_this.Caption), formCompany);
                    }
                    else {
                        return $dyn.value(_this.Caption);
                    }
                });
                _this.UseReactGrid = $dyn.computed(function () {
                    if (_this.DataSource && _this.DataSource.getValue) {
                        return $dyn.value(_this.DataSource.getValue("UseReactGrid"));
                    }
                    else {
                        return $dyn.util.isFlightEnabled($dyn.reactGrid.featureName);
                    }
                });
                // Check to see if the "ForceLegacyGrid" property on the form's viewmodel changes at runtime
                _this.ForceLegacyGrid = $dyn.observable(undefined);
                _this._INTERNAL_ForceLegacyGrid_Prev = $dyn.value(_this.ForceLegacyGrid);
                $dyn.observe(_this.ForceLegacyGrid, function (target) {
                    // Can be "0" or "1" as strings instead of numbers
                    // tslint:disable-next-line:triple-equals
                    if (_this._INTERNAL_ForceLegacyGrid_Prev == 0 && target == 1) {
                        // The form will be reloaded without React grid support on the next load, prompt the user
                        $dyn.warn({
                            Message: $dyn.label("Form_ReactGridUnsupported"),
                            Label: "Form_ReactGridUnsupported",
                        }, _this);
                    }
                    _this._INTERNAL_ForceLegacyGrid_Prev = target;
                });
                _this.panelManager = new Form.PanelManager(_this);
                /// Defer to get the form ready so that we can see if form has MessageBar
                /// then observe IsInViewMode to show/Hide ViewMode MessageBar
                /// ViewMode MessageBar is an indicator to show that the form is in view mode
                /// and should only appear on forms which can switch between view and edit mode (form.CanSwitchViewMode == true)
                _this.readyStatePromise = $dyn.deferred.onTrue(function () {
                    return $dyn.value(_this.ReadyState) === $dyn.ui.ReadyState.ready;
                });
                _this.readyStatePromise.done(function () {
                    $dyn.observe($dyn.options(function () {
                        return { viewMode: _this.IsInViewMode, isActive: _this.IsActive };
                    }), function (options) {
                        // The isActive value is false when the edit mode of the entire form is unchanged, so we can ignore it
                        // This occurs when the user clicks the company selector, settings button, or feedback button
                        if (options.isActive) {
                            if (!options.viewMode) {
                                // If the form just entered edit mode, unregister all Skype controls
                                $dyn.skypeInteraction.cacheRegisteredControls();
                                $dyn.skypeInteraction.unregisterAllControls();
                            }
                            else {
                                $dyn.skypeInteraction.processRegistrationCache();
                            }
                        }
                    });
                    if (_this.MessageBar) {
                        $dyn.observe($dyn.options(function () {
                            return { viewMode: _this.IsInViewMode, canSwitch: _this.CanSwitchViewMode };
                        }), function (options) {
                            _this.MessageBar.IsViewModeVisible(options.canSwitch && options.viewMode);
                        });
                    }
                    // initialize panel manager
                    _this.panelManager.init();
                });
                return _this;
            }
            Object.defineProperty(Form.prototype, "TakeFocus", {
                /**
                 * Gets whether or not this form instance should take focus when activated.
                 * @internal
                 * @returns Whether or not this form instance should take focus when activated.
                 */
                get: function () {
                    var shouldTakeFocus = true;
                    if (this._takeFocus === false) {
                        shouldTakeFocus = false;
                    }
                    else if (this.Root && this.Root !== this && this.Root.TakeFocus !== undefined) {
                        shouldTakeFocus = this.Root.TakeFocus;
                    }
                    return shouldTakeFocus;
                },
                /**
                 * Sets whether or not this form instance should take focus when activated.
                 * @internal
                 * @param value true if focus should be taking during activation; otherwise, false
                 */
                set: function (value) {
                    this._takeFocus = $dyn.peek(value);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "Id", {
                /**
                 * Gets the form's control Id
                 * @internal
                 */
                get: function () {
                    if (!this._formId && this.element) {
                        this._formId = this.element.getAttribute("data-dyn-formid");
                    }
                    return this._formId;
                },
                /**
                 * Sets the form's control Id
                 * @internal
                 * @param newId New Id
                 */
                set: function (newId) {
                    newId = $dyn.value(newId);
                    if (this.element) {
                        this.element.setAttribute("data-dyn-formid", newId);
                        this.element.setAttribute("id", "form_" + newId);
                    }
                    this._formId = newId;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "Name", {
                /**
                 * Gets the form's control name
                 * @internal
                 * @returns The form's "control" name
                 */
                get: function () {
                    return this._name;
                },
                /**
                 * Sets the form's control name
                 * @description Could represent an auto-generated name
                 * @internal
                 * @param newName New name
                 */
                set: function (newName) {
                    // The form does not emit the data-dyn-controlname attribute
                    this._name = $dyn.value(newName);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "FormName", {
                /**
                 * Gets the FormName based on the data-dyn-form-name attribute
                 * @internal
                 * @returns The FormName based on the data-dyn-form-name attribute
                 */
                get: function () {
                    if (!this._formName && this.element) {
                        this._formName = this.element.getAttribute("data-dyn-form-name");
                    }
                    return this._formName;
                },
                /**
                 * Sets the FormName on the data-dyn-form-name attribute
                 * @internal
                 * @param newName The FormName
                 */
                set: function (newName) {
                    newName = $dyn.value(newName);
                    if (this.element && newName) {
                        this.element.setAttribute("data-dyn-form-name", newName);
                    }
                    this._formName = newName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "ObjectName", {
                get: function () {
                    if (!this._objectName) {
                        this._objectName = $dyn.value(this.MenuItemName) || $dyn.value(this.FormName) || $dyn.value(this.Name) || "";
                    }
                    return this._objectName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "ClientId", {
                get: function () {
                    if (!this._clientId) {
                        // Ideally this should be a property not an attribute, but test automation doesn't support it.
                        this._clientId = this.element.getAttribute("data-dyn-clientId");
                    }
                    return this._clientId;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "ReadyState", {
                get: function () {
                    if (this.element) {
                        return this.element.dynReadyState;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "canActivate", {
                /**
                 * Gets a value indicating if a form can be activated
                 * @internal
                 * @returns True, the form can activate; otherwise, false
                 */
                get: function () {
                    return !$dyn.value(this.disposeOnClose) || !this.willBeClosed;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "MessageBar", {
                get: function () {
                    if (!this._messageBar && this.element) {
                        var $msgBar = $(this.element).find('[data-dyn-role="MessageBar"]');
                        if ($msgBar[0]) {
                            this._messageBar = $dyn.context($msgBar[0]);
                        }
                    }
                    return this._messageBar;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "FilterManager", {
                get: function () {
                    if (!this._filterManager && this.element) {
                        var $filterManager = $(this.element).find('[data-dyn-role="FilterManager"]');
                        if ($filterManager[0]) {
                            this._filterManager = $dyn.context($filterManager[0]);
                        }
                    }
                    return this._filterManager;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "FilterPaneControl", {
                get: function () {
                    if (!this._filterPane && this.element) {
                        var filterPaneElement = this.element.querySelector('[data-dyn-role="FilterPane"]');
                        if (filterPaneElement) {
                            this._filterPane = $dyn.context(filterPaneElement);
                        }
                    }
                    return this._filterPane;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "SidePanel", {
                /** @internal */
                get: function () {
                    if (!this._sidePanel && this.element) {
                        var _sidePanelElement = this.element.getElementsByClassName("SidePanel")[0];
                        var _tabbingHandlerDispose = $dyn.util.tabbingContainer(_sidePanelElement, $dyn.label("SidePanel_RegionTitle"));
                        var showListButtonContext_1 = $dyn.context(this.element.getElementsByClassName("button_showList")[0]);
                        var _sidePanelContext_1 = $dyn.context(_sidePanelElement);
                        this._sidePanel = {
                            Shortcuts: {
                                Escape: {
                                    Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                                    Handler: function (evt) {
                                        return this.toggleVisibility();
                                    },
                                    Description: $dyn.label("SidePanel_Close"),
                                    Category: $dyn.ui.ShortcutCategory.Close,
                                },
                            },
                            TabbingHandlerDispose: _tabbingHandlerDispose,
                            SidePanelElement: _sidePanelElement,
                            SidePanelContext: _sidePanelContext_1,
                            SidePanelListButton: showListButtonContext_1,
                            toggleVisibility: function () {
                                if (showListButtonContext_1 && showListButtonContext_1.Clicked && $dyn.value(showListButtonContext_1.Visible) && $dyn.value(showListButtonContext_1.Enabled)) {
                                    showListButtonContext_1.Clicked();
                                    return true;
                                }
                                return false;
                            },
                            Id: _sidePanelContext_1 && $dyn.value(_sidePanelContext_1.Id),
                            isOpen: function () {
                                return _sidePanelContext_1 && $dyn.value(_sidePanelContext_1.Visible);
                            },
                            close: function () {
                                if (this.isOpen()) {
                                    $dyn.async(function sidePanelClose() {
                                        this.toggleVisibility();
                                    }, 0, undefined, this);
                                    return true;
                                }
                                return false;
                            },
                        };
                    }
                    return this._sidePanel;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "FactBoxPane", {
                get: function () {
                    if (!this._factBoxPane && this.element) {
                        var element = $(this.element).find(".factBoxPane-container");
                        var tabbingHandlerDispose = $dyn.util.tabbingContainer(element[0], $dyn.label("FactBox_RegionTitle"));
                        var selectedIndex_1 = 0;
                        var factBoxElements = element.find('[data-dyn-role="FactBox"]');
                        var factBoxes_1 = [];
                        var factBoxMap_1 = {};
                        var factBoxCount_1 = 0;
                        // tslint:disable-next-line:prefer-for-of
                        for (var i = 0; i < factBoxElements.length; i++) {
                            var context_1 = $dyn.context(factBoxElements[i]);
                            if (context_1) {
                                factBoxes_1.push(context_1);
                                factBoxMap_1[context_1.Name] = factBoxCount_1++;
                            }
                        }
                        var UpdateSelectedIndex_1 = function (evt) {
                            var factBoxName = $dyn.context($(evt.target).closest('[data-dyn-role="FactBox"]')[0]).Name;
                            selectedIndex_1 = factBoxMap_1[factBoxName];
                        };
                        var Navigate_nth_FactBox_1 = function (factBoxIndex) {
                            selectedIndex_1 = factBoxIndex;
                            if (factBoxes_1[selectedIndex_1]) {
                                factBoxes_1[selectedIndex_1].expand();
                            }
                        };
                        var NavigateFactBox_1 = function (direction, evt) {
                            UpdateSelectedIndex_1(evt);
                            Navigate_nth_FactBox_1((((selectedIndex_1 + direction) % factBoxCount_1) + factBoxCount_1) % factBoxCount_1);
                        };
                        var formThis_1 = this;
                        this._factBoxPane = {
                            Shortcuts: {
                                Escape: {
                                    Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                                    Handler: function (evt) {
                                        formThis_1.ToggleFactBoxPane(evt);
                                    },
                                    Description: $dyn.label("FactBoxPane_Close"),
                                    Category: $dyn.ui.ShortcutCategory.Close,
                                },
                                FactBoxPane: {
                                    Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.f2 },
                                    Handler: function (evt) {
                                        formThis_1.ToggleFactBoxPane(evt, $dyn.forms.FactBoxFocusTarget.Form);
                                    },
                                    ShowToUser: false,
                                },
                                NextFactBox: {
                                    Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                                    Handler: function (evt) {
                                        return NavigateFactBox_1(1, evt);
                                    },
                                    Description: $dyn.label("FactBoxPane_Next"),
                                    Category: $dyn.ui.ShortcutCategory.Navigate,
                                },
                                PreviousFactBox: {
                                    Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                                    Handler: function (evt) {
                                        return NavigateFactBox_1(-1, evt);
                                    },
                                    Description: $dyn.label("FactBoxPane_Prev"),
                                    Category: $dyn.ui.ShortcutCategory.Navigate,
                                },
                                nthFactBox: {
                                    Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.numbers },
                                    Handler: function (evt) {
                                        var factBoxIndex = evt.which - $dyn.ui.KeyCodes.Number1;
                                        return Navigate_nth_FactBox_1(factBoxIndex);
                                    },
                                    Description: $dyn.label("FactBoxPane_nthFactBox"),
                                    Category: $dyn.ui.ShortcutCategory.Navigate,
                                },
                            },
                            TabbingHandlerDispose: tabbingHandlerDispose,
                            Id: "factBoxPane",
                            isOpen: function () {
                                return !$dyn.value(formThis_1.FactBoxPaneCollapsed);
                            },
                            close: function () {
                                if (this.isOpen()) {
                                    $dyn.async(function factBoxClose() {
                                        this.ToggleFactBoxPane();
                                    }, 0, undefined, formThis_1);
                                    return true;
                                }
                                return false;
                            },
                            hasFactBox: factBoxCount_1 > 0,
                        };
                    }
                    return this._factBoxPane;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "SystemDefinedManagedViewFiltersElement", {
                get: function () {
                    if (!this._systemDefinedManagedViewFiltersElement) {
                        this._systemDefinedManagedViewFiltersElement = $(this.element).find("[data-dyn-controlname=SystemDefinedManageViewFilters]")[0];
                    }
                    return this._systemDefinedManagedViewFiltersElement;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Form.prototype, "Preloaded", {
                /** @obsolete unused? */
                get: function () {
                    if (this.element) {
                        return this.element.dynPreloaded === true;
                    }
                },
                enumerable: false,
                configurable: true
            });
            /**
             * See if a part form is registered to a form
             * @internal
             * @param partFormId The form id of the part
             * @returns True if id is for one of the registred form parts, otherwise false
             */
            Form.prototype.containsPartForm = function (partFormId) {
                var e_1, _a;
                var foundPartForm = false;
                if (this._formParts && this._formParts.length > 0) {
                    try {
                        for (var _b = __values(this._formParts), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var formPart = _c.value;
                            if (formPart.Id === partFormId) {
                                foundPartForm = true;
                                break;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return foundPartForm;
            };
            /**
             * Method called from interaction handler when we just want to clean up client references and
             * don't need to make a server call
             * @internal
             */
            Form.prototype.PrepareClientOnlyClose = function () {
                this.RequestClose = (function () { });
                this.RequestCloseCancel = (function () { });
                if (this._formParts && this._formParts.length > 0) {
                    this._formParts.forEach(function (partForm) {
                        partForm.PrepareClientOnlyClose();
                    });
                }
            };
            /**
             * Check if any of the factboxes are visible
             * @internal
             * @description for client-only factboxes that did not get processed during the binding stage
             * check if any is visible that allows for the factbox pane and button to be visible
             */
            Form.prototype.OnClientFormLoaded = function () {
                if ($dyn.value(this.DelayedFactBoxLoad) && this.ObserveFactBoxes) {
                    this.DelayedFactBoxLoad = false;
                    this.ObserveFactBoxes();
                }
                // Apply views to part
                $dyn.observe(this.CurrentViewKey, this.ApplyViewForParts.bind(this));
                // linked
                $dyn.observe(this.SaveLinkedViews, this.ProcessSaveLinkedViews.bind(this));
            };
            /**
             * Shows or Hides hidden fields of form
             * @param show True when hidden fields are shown
             */
            Form.prototype.ShowOrHideHiddenFields = function (show) {
                $dyn.callFunction(this.ExecutePersonalizationCommand, this, ["ShowHiddenFields", show]);
            };
            Form.prototype.SavePendingPersonalization = function (serializedString) {
                $dyn.callFunction(this.PersistMultiplePersonalization, this, [serializedString]);
            };
            /**
             * Gets if views are enabled for form
             * @returns True, if views are enabled; otherwise, false
             */
            Form.prototype.IsViewsEnabled = function () {
                var viewsEnabled = false;
                var viewSelectorButton = $("[data-dyn-controlName = SystemDefinedManageViewFilters]");
                if (viewSelectorButton && viewSelectorButton.length > 0) {
                    viewsEnabled = true;
                }
                return viewsEnabled;
            };
            Form.prototype.controlRenderPending = function (controlName) {
                this.controlsWithAsyncRender[controlName] = true;
                if (!$dyn.value(this.waitForAsyncRender)) {
                    this.waitForAsyncRender(true);
                }
            };
            Form.prototype.controlRenderComplete = function (controlName) {
                if (this.controlsWithAsyncRender[controlName]) {
                    delete this.controlsWithAsyncRender[controlName];
                    if ($dyn.value(this.waitForAsyncRender) && Object.keys(this.controlsWithAsyncRender).length === 0) {
                        this.waitForAsyncRender(false);
                    }
                }
            };
            Form.prototype.reflow = function () {
                if (this.element) {
                    $dyn.layout.reflow(this.element, true);
                }
            };
            /**
             * Links the form parts with the host form
             * @internal
             * @param part the form part
             */
            Form.prototype.RegisterFormPart = function (part) {
                this._formParts.push(part);
                $dyn.observe(part.UnsavedViewChanges, this.LinkedPartViewChanged.bind(this));
            };
            Form.prototype.ApplyViewForParts = function () {
                var _this = this;
                $dyn.async(function () {
                    var partsCount = _this._formParts.length;
                    for (var i = 0; i < partsCount; i++) {
                        if (_this._formParts[i] && _this._formParts[i].ApplyViewForFormPart && $dyn.value(_this.CurrentViewKey) !== "") {
                            $dyn.callFunction(_this._formParts[i].ApplyViewForFormPart, _this._formParts[i], [$dyn.value(_this.CurrentViewKey)]);
                        }
                    }
                }, undefined, "Part from changes should fire after form has finished its other interactions");
            };
            /**
             * Fired when a form part is personlalized
             * @internal
             * @param isDirty true if dirty
             */
            Form.prototype.LinkedPartViewChanged = function (isDirty) {
                // only if server is not dirty already
                if (isDirty && !this.pendingViewDirtySync) {
                    this.pendingViewDirtySync = $dyn.async(this.SetDirtyLinkedViewState.bind(this));
                }
            };
            Form.prototype.ExecuteDefaultAction = function (event) {
                if (this.isNavigationActiveForm() && $dyn.value(this.DefaultActionEnabled) && $dyn.value(this.DefaultAction)) {
                    if (event) {
                        var control = $dyn.context(event.target);
                        if (control && control.updateValue) {
                            control.updateValue(true);
                        }
                        event.preventDefault();
                    }
                    // Update server on last selected control so it can retain focus if current form is still active after default action is executed.
                    this.updateLastClientSelectedControl();
                    $dyn.applyFunction(this.DefaultAction, this);
                }
            };
            /**
             * Represents that the form is on current navigation stack and hence can be interacted with.
             * @internal This is shell specific concept.
             * @returns True if the form is on current navigation stack; otherwise, false.
             */
            Form.prototype.isNavigationActiveForm = function () {
                return (this.element.classList.contains("active-form") ||
                    $(this.element)
                        .parents()
                        .hasClass("active-form") ||
                    $(this.element)
                        .parents()
                        .hasClass("navigationBar") ||
                    $(this.element)
                        .parents()
                        .hasClass("asidePane"));
            };
            /**
             * Gets if the form is current active form
             * @description isFormActive has a form scope and relates to the region of the current root form that the user can interact with.
             * This region could be a partform or a dialog or a simple control.
             * @internal
             *
             * @returns True if the form is active; otherwise, false.
             */
            Form.prototype.isFormActive = function () {
                return $dyn.value(this.IsActive);
            };
            Form.prototype.isInActiveFocusRegion = function () {
                var myFocusRegion = $(this.element).closest(".binding-focusRegion").attr("data-dyn-focus-region");
                if (!myFocusRegion) {
                    var flyout_1 = $(this.element).closest(".sysPopup");
                    var flyoutObject = $dyn.flyout.flyoutManager.getTopFlyout();
                    if (flyout_1 && flyoutObject) {
                        var topFlyout = $dyn.value(flyoutObject.flyout);
                        if (topFlyout && ($.contains(topFlyout[0], flyout_1[0]) || $(flyout_1[0]).is(topFlyout[0]))) {
                            return true;
                        }
                    }
                }
                return myFocusRegion === $dyn.shell.getActiveRegion();
            };
            Form.prototype.Open = function () {
                this.IsOpen(true);
            };
            Form.prototype.isPopup = function () {
                return this.TypeName === "Popup";
            };
            Form.prototype.IgnoreBlockingDiv = function (commandName) {
                return commandName === this.RequestCloseCommandName && $dyn.value(this.ReadyState) === $dyn.ui.ReadyState.aborted;
            };
            Form.prototype.GoGridView = function () {
                if ($dyn.value(this.ShowLinkToGridView)) {
                    $dyn.getFunction(this.OpenGridView)();
                }
            };
            Form.prototype.SetEditMode = function (val) {
                $dyn.setValue(this, "IsInViewMode", val);
            };
            Form.prototype.getTaskGuideParams = function (options) {
                // Check if the target should be redirected.
                var specialTarget;
                if (options.action.indexOf("RequestClose") !== -1) {
                    specialTarget = $(this.element).find('[data-dyn-controlname="SystemDefinedCloseButton"]')[0];
                }
                else if (options.action.indexOf("Refresh") !== -1) {
                    specialTarget = $(this.element).find('[data-dyn-controlname="SystemDefinedRefreshButton"]')[0];
                }
                else if (options.action.indexOf("ExecuteActionSearchClick") !== -1) {
                    return this.getTaskGuideParamsActionSearch(options);
                }
                if (specialTarget) {
                    $.extend(options, {
                        target: $(specialTarget),
                        my: "top center",
                        at: "bottom center",
                        adjustMethod: "flip",
                    });
                }
                else {
                    // Form level info steps show up at the top right corner without beak
                    $.extend(options, {
                        target: $(this.element),
                        my: "top right",
                        at: "top right",
                        adjust: {
                            x: -10,
                            y: 10,
                            method: "none",
                        },
                        styles: {
                            hideTip: true,
                        },
                    });
                }
                return options;
            };
            Form.prototype.RefreshData = function (recordable) {
                var refresh = $dyn.value(this.Refresh);
                if (typeof refresh === "function") {
                    var enableTaskRecording = void 0;
                    if (typeof recordable === "undefined") {
                        enableTaskRecording = true;
                    }
                    else {
                        enableTaskRecording = recordable;
                    }
                    refresh(enableTaskRecording);
                }
                else {
                    this.TriggerLocalRefresh(true);
                }
            };
            /**
             * Get all PartForms
             * @internal
             * @returns Returns an array of all PartForms (Embedded parts)
             */
            Form.prototype.GetAllPartForms = function () {
                var partForms = [];
                var partFormElements = $("[data-dyn-role='PartForm']", this.element);
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < partFormElements.length; i++) {
                    var partForm = partFormElements[i];
                    var context_2 = $dyn.context(partForm);
                    if (context_2) {
                        partForms.push(context_2);
                    }
                }
                return partForms;
            };
            /**
             * Get all factbox forms
             * @internal
             * @returns Returns an array of all FactBox Forms (Embedded parts)
             */
            Form.prototype.GetAllFactBoxForms = function () {
                var factBoxForms = [];
                var factBoxFormElements = $("[data-dyn-role='FactBoxForm']", this.element);
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < factBoxFormElements.length; i++) {
                    var factBoxForm = factBoxFormElements[i];
                    var context_3 = $dyn.context(factBoxForm);
                    if (context_3) {
                        factBoxForms.push(context_3);
                    }
                }
                return factBoxForms;
            };
            /**
             * Toggle the expansion of the FactBoxPane.
             * @description If the FactBoxPane is collapsed it get expanded and focus is set to the first FactBox header.
             * When the FactBoxPane is already expanded then, if a focusTarget is provided, then focus is toggled between Form and FactBox,
             * but if the focusTarget is not provided, then FactBoxPane is collapsed and the focus returned to the last selected control.
             * @internal
             * @param evt Event object
             * @param focusTarget Focus target control
             */
            Form.prototype.ToggleFactBoxPane = function (evt, focusTarget) {
                var _this = this;
                if (!focusTarget || $dyn.value(this.FactBoxPaneCollapsed)) {
                    this.HandleFactBoxPaneOpenClose($dyn.value(this.FactBoxPaneCollapsed));
                    $dyn.async(function () {
                        $dyn.callFunction(_this.PersistPersonalization, _this, ["factboxpaneexpanded", !$dyn.value(_this.FactBoxPaneCollapsed)]);
                    }, undefined, "async call ToggleFactBoxPane: Async required so that it does not interferese opening of fact box");
                    if ($dyn.isObservable(this.FactBoxPaneInitiallyExpanded)) {
                        this.FactBoxPaneInitiallyExpanded(!$dyn.value(this.FactBoxPaneCollapsed));
                    }
                }
                var doFocus = evt ? true : false;
                this.HandleFactBoxPaneFocus(doFocus, focusTarget);
            };
            /**
             * Toggle the expansion of the FactBoxPane if Enter key pressed.
             * @description If Enter pressed then call ToggleFactBoxPane method.
             * @internal
             *
             * @param evt Event object
             */
            Form.prototype.EnterToggleFactBoxPane = function (evt) {
                if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.enter })) {
                    this.ToggleFactBoxPane(evt);
                }
            };
            /** @internal */
            Form.prototype.escape = function (evt) {
                var _this = this;
                // When using this shortcut from an element just edited, the control may not have the latest value
                var control = evt ? $dyn.context(evt.target) : undefined;
                var isControlDirty = false;
                if (control && control.updateValue) {
                    control.updateValue(true);
                }
                if (control && control.isDisplayedValueDirty) {
                    isControlDirty = control.isDisplayedValueDirty();
                }
                if ($dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                    // If there are any flyouts open then dismiss those first.
                    $dyn.flyout.flyoutManager.removeTopFlyoutAsync();
                    return;
                }
                if ($dyn.value(this.IsInViewMode) || (!this.AreDataSourcesDirty() && !this.HasInvalidControls() && !isControlDirty)) {
                    // If the form is in ViewMode, or the form is in EditMode but not dirty, prompt if the user would like to leave the page when &debug=EscPromptWhenNotDirty flag is set.
                    // User should not have any unsaved changes in this case.
                    if ($dyn.debug.EscPromptWhenNotDirty) {
                        $dyn.showMessageBox({
                            showYesButton: true,
                            showNoButton: true,
                            ShowActivityId: false,
                            Text: $dyn.label("Form_DoYouWantToLeave"),
                            callback: function (btn) {
                                if (btn === $dyn.controls.MessageBox.Button.Yes) {
                                    if (_this.hasMultipleNavigationEntries()) {
                                        // If the form has multiple views, just do a back navigation and no Task_ESC
                                        _this.AllowSave($dyn.shell.initiateBack);
                                    }
                                    else {
                                        // If the form has single view, close the form and call Task_ESC
                                        _this.executeShortcuts(false, "EscapeSaveYES");
                                    }
                                }
                                // MessageBox was dismissed. Do nothing.
                            },
                        });
                    }
                    else {
                        // No prompt if &debug=EscPromptWhenNotDirty flag is not set.
                        if (this.hasMultipleNavigationEntries()) {
                            // If the form has multiple views, just do a back navigation and no Task_ESC
                            this.AllowSave($dyn.shell.initiateBack);
                        }
                        else {
                            // If the form has single view, close the form and call Task_ESC
                            this.executeShortcuts(false, "EscapeSaveYES");
                        }
                    }
                }
                else {
                    // The form is in EditMode and has unsaved server side or client side changes.
                    // Prompt if the user would like to save changes before closing.
                    $dyn.showMessageBox({
                        showYesButton: true,
                        showNoButton: true,
                        showCancelButton: true,
                        ShowActivityId: false,
                        Text: $dyn.label("Form_DoYouWantToSave"),
                        callback: function (btn) {
                            if (btn === $dyn.controls.MessageBox.Button.Yes) {
                                _this.EscapeSaveYes();
                            }
                            else if (btn === $dyn.controls.MessageBox.Button.No) {
                                if (_this.hasMultipleNavigationEntries()) {
                                    // If the form is in the detail view of a List/Details pattern, just go back to the list view
                                    _this.executeShortcuts(false, "Restore", evt);
                                    _this.AllowSave($dyn.shell.initiateBack);
                                }
                                else {
                                    // It's not possible to discard changes and navigate back to previous view, so close the form without saving and call Task_ESC.
                                    _this.executeShortcuts(false, "EscapeSaveNO");
                                }
                            }
                            // MessageBox was dismissed. Do nothing.
                        },
                    });
                }
            };
            /** @internal */
            Form.prototype.EscapeSaveYes = function () {
                if (this.hasMultipleNavigationEntries()) {
                    // If the form has multiple views, just do a back navigation and no Task_ESC
                    this.AllowSave($dyn.shell.initiateBack);
                }
                else {
                    // If the form has single view, close the form and call Task_ESC
                    this.executeShortcuts(true, "EscapeSaveYES");
                }
            };
            /**
             * Check if form's datasources are dirty
             * @internal
             * @returns True if form's datasources are dirty; otherwise false.
             */
            Form.prototype.AreDataSourcesDirty = function () {
                if (this.DataSource && this.DataSource._relatedCollections) {
                    for (var collectionName in this.DataSource._relatedCollections) {
                        if (this.DataSource._relatedCollections[collectionName].IsDirty) {
                            return true;
                        }
                    }
                }
                return false;
            };
            /**
             * Launch the personalization toolbar.
             * @description Trigger the event to enter personalization mode for the form.
             * @internal
             */
            Form.prototype.personalize = function () {
                if ($dyn.value(this.AllowExplicitPersonalization)) {
                    $(window).trigger($dyn.forms.Events.personalize);
                }
            };
            Form.prototype.executeShortcuts = function (causingSave, keyCombination, evt, commandCallback) {
                var _this = this;
                var control = evt ? $dyn.context(evt.target) : undefined;
                // when using these shortcuts from an element just edited, the control may not have the latest value
                // If the shortcut will save the record, or change the active record we need SetValue to be sent first.
                if (control) {
                    if (control.updateValue) {
                        control.updateValue(true);
                    }
                    if (control.focusOutCleanup) {
                        control.focusOutCleanup(true);
                    }
                }
                if (causingSave) {
                    this.AllowSave(function () {
                        // Clear any messages in MessageBar as server will resend messages for any data that is still invalid when attempting to save.
                        if (_this.MessageBar) {
                            _this.MessageBar.ClearMessages();
                        }
                        $dyn.callFunction(_this.ExecuteShortcuts, _this, [keyCombination], commandCallback);
                    });
                }
                else {
                    $dyn.callFunction(this.ExecuteShortcuts, this, [keyCombination], commandCallback);
                }
            };
            /**
             * Handles keydown events when this is the active form.
             * @description This method is not registered using an event handler or binding, but is called by the shell when the form is the active form and a keydown event occurs.
             * SidePanel handles keydown first if event target was within it.
             * @internal
             * @param event Event object
             */
            Form.prototype.keydown = function (event) {
                var isHandledBySidePanel = false;
                if ($(event.target)
                    .parents()
                    .is(".SidePanel")) {
                    $dyn.util.handleShortcuts(this.SidePanel, event);
                    isHandledBySidePanel = event.isPropagationStopped();
                }
                if (!isHandledBySidePanel) {
                    $dyn.util.handleShortcuts(this, event);
                }
            };
            /**
             * Handles keydown events when the focus is in the FactBoxPane.
             * @internal
             * @param event Event object
             */
            Form.prototype.FactBoxPanekeyDown = function (event) {
                $dyn.util.handleShortcuts(this.FactBoxPane, event);
            };
            /** @internal */
            Form.prototype.goToActionSearch = function () {
                if ($dyn.value($dyn.debug.combinedSearch)) {
                    this.goToSearchField(".combinedSearch-actions", 2);
                }
                else {
                    var searchElement = this.element.getElementsByClassName("actionSearch")[0];
                    var searchControl = $dyn.context(searchElement);
                    this.focusSearchControl(searchControl, searchElement);
                }
            };
            Form.prototype.FocusIn = function (evt) {
                $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->FocusIn", this.Id);
                // stop the focus event if we can not focus
                if (!$dyn.shell.canFocus(this)) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->FocusIn invalid focus attempt", this.Id);
                    evt.stopImmediatePropagation();
                    evt.preventDefault();
                    return;
                }
                var lastActiveElement = this.ActiveElement();
                var activeElement = evt.target;
                activeElement = $(activeElement)
                    .addBack()
                    .closest("[data-dyn-controlname]")[0];
                var activeContext = $dyn.ui.getLiveControl(activeElement);
                // only act on the focus event if it's for an element belonging to this form
                if (!activeContext || !activeContext.Root || this.Id === activeContext.Root.Id) {
                    this.focusedControl = activeElement;
                    this.InternalFocusIn(activeElement, lastActiveElement);
                }
            };
            /**
             * Sets the active control on the form and sends an interaction to sync with the server under some conditions.
             * @internal
             * @param activeControl the control to be set as active
             * @param syncWithServer Should sync with the server
             * @param updateBoundaryInfo Should update boundry info
             * @param forceFocus Force update the ActiveControl observable
             */
            Form.prototype.activateControl = function (activeControl, syncWithServer, updateBoundaryInfo, forceFocus) {
                // if we are crossing a boundary, or going to a control that doesn't require a cross boundary
                if (updateBoundaryInfo) {
                    this.ActiveBoundaryInfo = { DataSource: activeControl.DataSource, ServiceBoundary: activeControl.ServiceBoundary };
                }
                if (forceFocus || $dyn.value(this.ActiveControl) !== activeControl.Name) {
                    $dyn.setValue(this, "ActiveControl", activeControl.Name, forceFocus);
                    if (this.SetServerSelectedControl && syncWithServer) {
                        $dyn.callFunction(this.SetServerSelectedControl, this, [activeControl.Name]);
                    }
                }
            };
            Form.prototype.isActiveControl = function (controlName) {
                if (this.focusedControl) {
                    var control = $dyn.ui.getLiveControl(this.focusedControl);
                    if (control && control.Name === controlName) {
                        return true;
                    }
                }
                return false;
            };
            Form.prototype.GetFocusedControl = function () {
                return this.focusedControl;
            };
            Form.prototype.ActiveElementInMainFormContainer = function () {
                return this._formActiveElement;
            };
            /** @internal */
            Form.prototype.RestoreFocusToMainFormFirstVisibleControl = function () {
                // Restore focus to first visible field in the main form content has the rootContent class.
                // This content region doesn't include FactBox pane, SidePanel or FilterPane.
                var rootContentElement = this.element.querySelector(".rootContent");
                var newActiveElement;
                if (rootContentElement) {
                    newActiveElement = $dyn.util.findFirstFocusableControl(rootContentElement);
                    this.InternalFocusIn(newActiveElement, this.ActiveElement(), true);
                }
            };
            Form.prototype.RestoreFocusToMainFormContainer = function () {
                // Restore focus to the main form (from a different tabbing container such as the appbar).
                // If there is no active element stored there, find the first focusable control.
                var newActive = this.ActiveElementInMainFormContainer();
                if (newActive) {
                    this.InternalFocusIn(newActive, this.ActiveElement(), true);
                }
                else {
                    this.focusFirstControl(true);
                }
            };
            /** @internal */
            Form.prototype.InternalFocusIn = function (activeElement, lastActiveElement, forceFocus) {
                var _this = this;
                $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->InternalFocusIn", this.Id);
                if (lastActiveElement !== activeElement) {
                    var lastId = lastActiveElement ? lastActiveElement.id : "";
                    var activeId = activeElement ? activeElement.id : "";
                    if (lastId && activeId && lastId === activeId && !lastActiveElement.isConnected) {
                        $dyn.log.focus && $dyn.log.focus("Setting focus to same id but previous element is no longer connected to DOM");
                        this.updateActiveElement(activeElement);
                        return;
                    }
                }
                var lastActiveControl = $dyn.ui.getLiveControl(lastActiveElement);
                var activeControl = $dyn.ui.getLiveControl(activeElement);
                /// #DEBUG
                if ($dyn.log.focus) {
                    var activeName = void 0;
                    var lastName = "";
                    if (activeControl) {
                        activeName = activeControl.Name;
                        if (activeControl.DataSource && $dyn.value(activeControl.DataSource.collectionIndex)) {
                            activeName += "[" + $dyn.value(activeControl.DataSource.collectionIndex) + "]";
                        }
                    }
                    if (lastActiveControl) {
                        lastName = lastActiveControl.Name;
                        if (lastActiveControl.DataSource && $dyn.value(lastActiveControl.DataSource.collectionIndex)) {
                            lastName += "[" + $dyn.value(lastActiveControl.DataSource.collectionIndex) + "]";
                        }
                    }
                    else if (lastActiveElement) {
                        lastName = $(lastActiveElement)
                            .addBack()
                            .closest("[data-dyn-controlname]")
                            .attr("data-dyn-controlname");
                    }
                    $dyn.log.focus("Focus: Form(Form.Id: %s)->InternalFocusIn - active control: %s, last active control: %s, document.activeElement: %o", this.Id, activeName, lastName, document.activeElement);
                }
                /// #ENDDEBUG
                if (lastActiveElement !== activeElement) {
                    // Generally we do not set focus to a container control.
                    // However, forceFocus can suppress this for specific cases such as focusing to fastab header when there is no focusable control inside the tab page.
                    if (!activeControl || (activeControl.isContainer && !forceFocus)) {
                        return;
                    }
                    var crossBoundary = this.AreControlsCrossBoundary(activeControl, lastActiveControl);
                    var syncControl = void 0;
                    var sameRefGroup = void 0;
                    if (lastActiveControl) {
                        syncControl = $dyn.value(lastActiveControl.OnLeaveEnabled);
                        sameRefGroup = activeControl.ReferenceGroup
                            && lastActiveControl.ReferenceGroup
                            && activeControl.ReferenceGroup === lastActiveControl.ReferenceGroup;
                        // if the last active control didn't do a boundary check, we need to do one with the boundary we were in before activating that control
                        var lastCanAcquireFocus = lastActiveControl.CanAcquireFocus === undefined ? true : $dyn.util.stringToBoolean($dyn.value(lastActiveControl.CanAcquireFocus));
                        if (!crossBoundary && !lastCanAcquireFocus && this.ActiveBoundaryInfo) {
                            crossBoundary = this.AreControlsCrossBoundary(activeControl, this.ActiveBoundaryInfo);
                        }
                    }
                    // In case elements are considered 'cross boundary', we need to check whether they are within a list control
                    // In that case list does additional validation
                    var activeElementInFastEditGrid = void 0;
                    if (crossBoundary) {
                        if (lastActiveControl && lastActiveControl.listControl &&
                            activeControl && activeControl.listControl &&
                            activeControl.listControl === lastActiveControl.listControl) {
                            crossBoundary = activeControl.listControl.AreControlsCrossBoundary(activeControl, lastActiveControl);
                            activeElementInFastEditGrid = true;
                        }
                        else {
                            var lastActiveElementList = this._getParentListByElement(lastActiveElement);
                            var activeElementList = this._getParentListByElement(activeElement);
                            if (activeElementList) {
                                activeElementInFastEditGrid = $dyn.value(activeElementList.FastEdit);
                            }
                            // Should also check if last control was a fast edit grid
                            if (!activeElementInFastEditGrid && lastActiveElementList) {
                                activeElementInFastEditGrid = $dyn.value(lastActiveElementList.FastEdit);
                            }
                            if (lastActiveElementList && activeElementList && activeElementList.AreElementsCrossBoundary && activeElementList === lastActiveElementList) {
                                var listCrossBoundary = activeElementList.AreElementsCrossBoundary(activeElement, lastActiveElement);
                                if (listCrossBoundary !== undefined) {
                                    crossBoundary = listCrossBoundary;
                                }
                            }
                        }
                    }
                    // If canAcquireFocus is undefined (not specified) or true, then we should do the cross boundary check
                    var canAcquireFocus = activeControl.CanAcquireFocus === undefined ? true : $dyn.util.stringToBoolean($dyn.value(activeControl.CanAcquireFocus));
                    // If both last and current active control are children are in the same referenceGroup, there is no need to call SetServerSelectedControl.
                    if (!sameRefGroup && canAcquireFocus && (syncControl || crossBoundary || $dyn.value(activeControl.OnEnterEnabled) || $dyn.value(this.OnSelectControlEnabled))) {
                        if (crossBoundary) {
                            $dyn.log.focus &&
                                $dyn.log.focus("Crossing service boundary: %s, from: %s, active control: %s, previous control: %s", activeControl.ServiceBoundary, lastActiveControl ? lastActiveControl.ServiceBoundary : "", activeControl.Name, lastActiveControl ? lastActiveControl.Name : "");
                            if (this.HasInvalidControls() || $dyn.callFunction($dyn.async.IsClientProcessing) || $dyn.util.waitForClientBusy()) {
                                var successCallback = function () {
                                    _this.activateControl(activeControl, true, true, forceFocus);
                                };
                                // Throw error dialog after pending interactions (if any) if there is an invalid control
                                this.AllowSave(successCallback, undefined, activeElementInFastEditGrid);
                            }
                            else {
                                this.activateControl(activeControl, true, true, forceFocus);
                            }
                        }
                        else {
                            this.activateControl(activeControl, true, false, forceFocus);
                        }
                    }
                    else {
                        this.activateControl(activeControl, false, false, forceFocus);
                    }
                }
            };
            Form.prototype.updateLastClientSelectedControl = function () {
                if (this.UpdateLastSelectedControl) {
                    var formActiveElement = this.ActiveElementInMainFormContainerOrSidePanel();
                    if (!formActiveElement || !$(formActiveElement).is(":visible")) {
                        formActiveElement = $dyn.value(this.ActiveElement);
                    }
                    var prevSelectedControl = $dyn.ui.getLiveControl(formActiveElement);
                    if (prevSelectedControl) {
                        if (prevSelectedControl.ServerFocusableControl) {
                            prevSelectedControl = prevSelectedControl.ServerFocusableControl;
                        }
                        if ($dyn.value(prevSelectedControl.CanAcquireFocus) !== false) {
                            $dyn.callFunction(this.UpdateLastSelectedControl, this, [prevSelectedControl.Name]);
                        }
                    }
                }
            };
            // move to Form_IsActiveChanged with 360478
            Form.prototype.takeNavigationFocus = function () {
                var _this = this;
                if ($dyn.flyout.flyoutManager.tryTakeNavigationFocus(this)) {
                    // A nested flyout took focus. Exit early.
                    return;
                }
                // make sure the active control is in the form
                var controlName = this.ActiveControl();
                if (!controlName) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s  Control: %s)->takeNavigationFocus no ActiveControl", this.Id, controlName);
                    this.focusFirstControl();
                    return;
                }
                var controlElement = this.findControl(controlName);
                if (controlElement) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s Control: %s)->takeNavigationFocus", this.Id, controlName);
                    this.setControlFocus(this.ActiveControl());
                }
                else {
                    var focusDelay_1 = function () {
                        controlElement = _this.findControl(controlName);
                        if (controlElement) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s Control: %s)->takeNavigationFocus focusDelay", _this.Id, controlName);
                            _this.setControlFocus(_this.ActiveControl());
                        }
                        else if ($dyn.value(_this.waitForAsyncRender)) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s Control: %s)->takeNavigationFocus delay for grid render", _this.Id, controlName);
                            $dyn.observe(_this.waitForAsyncRender, function (value) {
                                if (!value) {
                                    focusDelay_1();
                                    return false;
                                }
                            }, _this, undefined, true);
                        }
                        else {
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s Control: %s)->takeNavigationFocus focusDelay no ActiveControl", _this.Id, controlName);
                            _this.focusFirstControl();
                        }
                    };
                    if ($dyn.async.IsClientProcessing()) {
                        $dyn.log.focus &&
                            $dyn.log.focus("Focus: Form(Form.Id: %s Control: %s)->takeNavigationFocus IsClientProcessing delaying focus to allow parts / grids to load", this.Id, controlName);
                        var subscriberId_2 = $dyn.clientBusy.valueChanged.subscribe(function (value) {
                            focusDelay_1();
                            $dyn.clientBusy.valueChanged.unsubscribe(subscriberId_2);
                        });
                    }
                    else {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s Control: %s)->takeNavigationFocus microTask delaying focus to allow parts / grids to load", this.Id, controlName);
                        $dyn.microTask(function () {
                            focusDelay_1();
                        });
                    }
                }
            };
            Form.prototype.changeDetailsViewElement = function (tab, activeTabName) {
                if (tab && tab.Root && tab.Root.SystemDefinedManagedViewFiltersElement) {
                    var activeTab = $(tab.element).find('[data-dyn-controlname="' + activeTabName + '"]')[0];
                    if (activeTab && $dyn.context(activeTab) && $dyn.value($dyn.context(activeTab).PanelStyle) === "Grid") {
                        tab.Root.moveSystemDefinedManageViewFilters($dyn.forms.ViewsButtonLocation.MainCaption);
                    }
                    else {
                        tab.Root.moveSystemDefinedManageViewFilters($dyn.forms.ViewsButtonLocation.TopContext);
                    }
                    tab.Root.systemDefinedManagedViewFiltersElementDetailsMasterMoved = true;
                }
            };
            Form.prototype.adjustSystemDefinedManageViewFilters = function () {
                // only process if root elements
                if (!this.Root && this.SystemDefinedManagedViewFiltersElement) {
                    switch ($dyn.value(this.Style)) {
                        // place in main area of caption
                        case $dyn.forms.Styles.ListPage:
                        case $dyn.forms.Styles.SimpleList:
                            this.moveSystemDefinedManageViewFilters($dyn.forms.ViewsButtonLocation.MainCaption);
                            break;
                        // place in main area of caption - special case
                        case $dyn.forms.Styles.DetailsFormMaster:
                        case $dyn.forms.Styles.DetailsFormTransaction:
                            // need to find the main tab page
                            var parentTab = $dyn.context($(this.element).find("[data-dyn-role=Pivot]")[0]);
                            if (parentTab && parentTab.ActiveItemName) {
                                this.changeDetailsViewElement(parentTab, $dyn.value(parentTab.ActiveItemName));
                            }
                            break;
                        // place at top with small entity name
                        case $dyn.forms.Styles.SimpleListDetails:
                            this.moveSystemDefinedManageViewFilters($dyn.forms.ViewsButtonLocation.TopEntityName);
                            break;
                        // place at top with context
                        default:
                            this.moveSystemDefinedManageViewFilters($dyn.forms.ViewsButtonLocation.TopContext);
                            break;
                    }
                }
            };
            /**
             * Restore focus if the active element is inside the container element.
             * @internal
             * @param containerElement The container element
             */
            Form.prototype.restoreFocus = function (containerElement) {
                var controlToFocus;
                if ($dyn.value(this.ActiveControl)) {
                    var controlElement = $dyn.ui.findControlElement(this.ActiveControl(), this.element);
                    if (controlElement && $dyn.util.isChild(containerElement, controlElement)) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->restoreFocus setting focus to ActiveControl: %s", this.Id, this.ActiveControl());
                        controlToFocus = this.ActiveControl();
                    }
                }
                else if ($dyn.value(this.ActiveElement)) {
                    // The focused element may have lost focus in the case of a grid re-render, causing the document body to have the focus
                    // Don't prevent the call to setControlFocus() when the focused element is the same as the active element
                    if ($dyn.util.isChild(containerElement, this.ActiveElement())) {
                        var control = $dyn.context(this.ActiveElement());
                        if (control) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->restoreFocus setting focus to ActiveElement: %s", this.Id, control.Name);
                            controlToFocus = control.Name;
                        }
                    }
                }
                // Restore focus to the control only if the parent form is currently active.
                if (this.isFormActive() && controlToFocus) {
                    // RestoreFocus should be called after the elements have been added to the form, so no need to call an async focus
                    this.setControlFocus(controlToFocus);
                }
                else {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->restoreFocus tried to restore focus on a non-active form or didn't find a control", this.Id);
                }
            };
            /**
             * Set focus to the control.
             * @internal
             * @param controlParam Either a DOM element, or a string with the metadata name of the control to focus.
             * @param forceFocus Should force focus
             */
            Form.prototype.setControlFocus = function (controlParam, forceFocus) {
                var _this = this;
                if ($dyn.value(this.ReadyState) === $dyn.ui.ReadyState.aborted) {
                    return;
                }
                // For preview. lookups, flyout forms.
                if (!this.TakeFocus) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->setControlFocus takeFocus is false", this.Id);
                    var focusTarget = this.FindFocusTarget ? this.FindFocusTarget() : undefined;
                    if (focusTarget && focusTarget[0]) {
                        var control = $dyn.ui.getLiveControl(focusTarget[0]);
                        if (control && control.Root) {
                            control.Root.setControlFocus(control.Name, this.isNavigationActiveForm() || (control.Root.isNavigationActiveForm && control.Root.isNavigationActiveForm()));
                        }
                        else {
                            focusTarget.focus();
                        }
                    }
                    return;
                }
                if (controlParam) {
                    var controlElement = void 0;
                    var controlName = void 0;
                    if (typeof controlParam === "string") {
                        controlName = controlParam;
                        // ActiveControl needs to be in sync with the control that is being focused
                        if (controlName !== $dyn.value(this.ActiveControl)) {
                            this.ActiveControl(controlName);
                            return; // ActiveControl observer will call setControlFocus again
                        }
                        else {
                            controlElement = this.findControl(controlParam);
                        }
                    }
                    else {
                        controlElement = controlParam;
                        controlName = $(controlElement)
                            .addBack()
                            .closest("[data-dyn-controlname]")[0]
                            ? $(controlElement)
                                .addBack()
                                .closest("[data-dyn-controlname]")[0]
                                .getAttribute("data-dyn-controlname")
                            : "";
                        if (controlName !== $dyn.value(this.ActiveControl)) {
                            this.ActiveControl(controlName);
                            return; //  ActiveControl observer will call setControlFocus again
                        }
                    }
                    // if there is no control to focus return
                    if (!controlElement) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->setControlFocus (control not found no-op) control name: %s", this.Id, controlName);
                        return;
                    }
                    if (controlElement) {
                        var control = $dyn.ui.getLiveControl(controlElement);
                        // Prevent focus on disabled controls
                        if (control && !$dyn.value(control.Enabled)) {
                            $dyn.log.focus && $dyn.log.focus("Focus prevented for disabled control name: %s", controlName);
                            return;
                        }
                        // If the control being focused is in overflow menu of action pane or toolbar then focus the overflow button instead
                        if (control && control.isInOverflow) {
                            var $overflowMenu = $(controlElement).closest(".overflow-menu");
                            if ($overflowMenu && $overflowMenu.length) {
                                var overflowButton = $dyn.context($overflowMenu[0]);
                                if (overflowButton && !$dyn.value(overflowButton.MenuOpen)) {
                                    this.ActiveControl(overflowButton.Name);
                                    return; // ActiveControl observer will call setControlFocus again
                                }
                            }
                        }
                        if ($dyn.util.isControlFocused(controlElement, this) ||
                            (control && control.Root && control.Root.UseReactGrid() && control.isInGrid() && $dyn.util.isColumnFocused(controlElement))) {
                            this.updateActiveElement(controlElement);
                            return;
                        }
                        // check to see if its a container control
                        var focusClass = controlElement.getAttribute("data-dyn-focus");
                        if (control && $dyn.value(control.isContainer) && (focusClass === "" || focusClass === undefined || focusClass === null)) {
                            // Delegate setting focus to a child control to its container.
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->setControlFocus container control name: %s", this.Id, controlName);
                            var $headerElement = control.getHeader
                                // Cast to any is to catch HTMLElement -- it will be converted in the next if check.
                                ? control.getHeader()
                                : undefined;
                            if ($headerElement && !($headerElement instanceof jQuery)) {
                                $headerElement = $($headerElement);
                            }
                            // If child element asked for focus is header then context of the control is same as container control and hence we should set focus to that header element
                            if ($headerElement && $headerElement.length > 0) {
                                var headerElementName = $headerElement.attr("data-dyn-controlName");
                                if (headerElementName && headerElementName === controlName) {
                                    $headerElement.focus();
                                    return;
                                }
                            }
                            var focusedControl = control.setChildControlFocus ? control.setChildControlFocus() : undefined;
                            if (focusedControl) {
                                return;
                            }
                            // No control was found to be focused. The container should be focused, which will delegate focus setting to the tab header or another element.
                        }
                        // Delay setting focus to end of the browser stack frame. This is done to ensure that all tasks that result from on action have completed before focus is set.
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->setControlFocus->Delay setting focus to - control name:' %s ' as a microTask", this.Id, controlName);
                        this.elementToFocus = controlElement;
                        this.elementToFocusName = controlName;
                        if (!this.isSetControlFocusCalled) {
                            this.isSetControlFocusCalled = true;
                            $dyn.microTask(function () {
                                $dyn.log.focus && $dyn.log.focus("Focus: Form->SetControlFocus->Executing MicroTask to set focus to control '%s'", _this.elementToFocusName);
                                $dyn.callFunction(_this.form_setFocus, _this, _this.elementToFocus, forceFocus);
                                _this.elementToFocus = null;
                                _this.elementToFocusName = "";
                                _this.isSetControlFocusCalled = false;
                            });
                        }
                    }
                }
                else {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->setControlFocus - No control name to set focus to", this.Id);
                }
            };
            Form.prototype.updateActiveElement = function (controlElement) {
                this.ActiveElement(controlElement);
                var $parents = $(controlElement).parents();
                if (!$parents.is(".appBar,.appBar-flyout,.navigationBar,.toolbar,.filterPane,.filterDisplay-addField-flyOut,.asidepane,.SidePanel,.factBoxPane-container,.overflow-menu,.messageBar")) {
                    this._formActiveElement = controlElement;
                    this._formOrSidePanelActiveElement = controlElement;
                }
                else if ($parents.is(".SidePanel")) {
                    this._formOrSidePanelActiveElement = controlElement;
                }
            };
            Form.prototype.form_setFocus = function (controlParam, forceFocus) {
                var _this = this;
                if (!controlParam) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (Enter) - no-op with empty controlParam : %s", this.Id);
                    return;
                }
                var controlElement;
                var controlName;
                if (typeof controlParam === "string") {
                    controlElement = this.findControl(controlParam);
                    controlName = controlParam;
                }
                else {
                    controlElement = controlParam;
                    var controlContext = $dyn.context(controlParam);
                    controlName = controlContext ? controlContext.Name : controlParam.getAttribute("data-dyn-controlname");
                }
                $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (Enter) - control name: %s", this.Id, controlName);
                var $controlElement = $(controlElement);
                // When the grid is empty, the find the first focusable control will retrieve the input control in grid cell as the active element.
                // It is a dummy control and should not be an active element.
                var gridClass = $dyn.value(this.UseReactGrid) ? ".react-listRoot" : ".listRoot";
                var parentElements = $controlElement.closest(gridClass);
                var shouldFocusActiveElement = true;
                if (parentElements.length > 0) {
                    var listControl = $dyn.context(parentElements[0]);
                    if (listControl) {
                        if ($dyn.value(this.UseReactGrid)) {
                            var reactList = listControl;
                            // Don't need to focus element if grid is pending render, its post render handles focus
                            shouldFocusActiveElement = !this.controlsWithAsyncRender[reactList.Name];
                            if (shouldFocusActiveElement) {
                                shouldFocusActiveElement = reactList.tryFocus(controlElement);
                            }
                        }
                        else {
                            var oldList = listControl;
                            // if the row is a place hold
                            var rowElement = parentElements.find(".rowTemplate");
                            if (rowElement.length === 0 || rowElement.hasClass("place-holder")) {
                                var headerRow = $controlElement.closest(".listAsTable-HeaderRow");
                                if (headerRow.length === 0 || !$dyn.value(oldList.AllowHeaderFocus)) {
                                    controlElement = null;
                                }
                            }
                            if (oldList.tryFocus) {
                                shouldFocusActiveElement = oldList.tryFocus(controlElement);
                                if (shouldFocusActiveElement && oldList.getNoRowIndicator) {
                                    var noRowIndicator = oldList.getNoRowIndicator();
                                    // Here if grid has tried to set focus on no row indicator then it should also update the active element of form
                                    if (noRowIndicator && noRowIndicator.length > 0 && document.activeElement === noRowIndicator[0]) {
                                        controlElement = noRowIndicator[0];
                                    }
                                }
                            }
                        }
                    }
                }
                this.updateActiveElement(controlElement);
                if (!shouldFocusActiveElement) {
                    return;
                }
                if (forceFocus || this.isNavigationActiveForm()) {
                    if (controlElement) {
                        var control = $dyn.ui.getLiveControl(controlElement);
                        if (!control || !control.IsServerFocusable || control.IsServerFocusable()) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (Enter) - Set focus to: %s", this.Id, controlName);
                            // Set the focus completed flag to false initially.
                            $dyn.focusCompleted(false);
                            // Delete any observers before creating new ones.
                            if (this.focusCompletedSubscription) {
                                $dyn.focusCompleted.valueChanged.unsubscribe(this.focusCompletedSubscription);
                                this.focusCompletedSubscription = undefined;
                            }
                            // Observe the focusCompleted flag to set the focusedControl property on the form.
                            this.focusCompletedSubscription = $dyn.focusCompleted.valueChanged.subscribe(function (focusCompleted) {
                                if ($dyn.value(focusCompleted)) {
                                    _this.focusedControl = controlElement;
                                    var focusedElement_1 = document.activeElement;
                                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (Exit) - Focus set to: %s, %s", _this.Id, controlName, focusedElement_1);
                                    if (focusedElement_1 && focusedElement_1.focus && document.activeElement !== document.body) {
                                        // Using setTimeout because this needs to be $dyn.async/clientBusy side-effect free
                                        setTimeout(function () {
                                            // In IE the focus can succeed during the micro task but IE can still lose focus to the body without a call to blur, detach element, etc.
                                            if (document.activeElement === document.body || document.activeElement === null) {
                                                focusedElement_1.focus();
                                                $dyn.log.focus &&
                                                    $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (retry) - focus set to : %s, %s", _this.Id, controlName, focusedElement_1, document.activeElement);
                                            }
                                        });
                                    }
                                    // if document.activeElement == body we failed to set focus try to keep foucs in the form
                                    if (document.activeElement === document.body) {
                                        $dyn.log.focus &&
                                            $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus->focusCompletedSubscription - Focus failed try to keep foucs in the form: %s, %s", _this.Id, controlName, focusedElement_1);
                                        var inEditMode = !$dyn.value(_this.IsInViewMode);
                                        var first = $dyn.util.findFirstFocusableControl(_this.element, true, inEditMode, inEditMode);
                                        if (first) {
                                            first.focus();
                                        }
                                    }
                                    $dyn.focusCompleted.valueChanged.unsubscribe(_this.focusCompletedSubscription);
                                    _this.focusCompletedSubscription = undefined;
                                }
                            });
                            // If a control context exists, then delegate focus setting to the control.
                            // Else, set focus to the dom element.
                            var focusCallback = control
                                ? control.focusCallback
                                : function (options) {
                                    if (options && options[0]) {
                                        $dyn.util.focusElement(options[0], controlName);
                                    }
                                };
                            // Queue focuscallback that sets focus to a control.
                            $dyn.shell.focusCallback(focusCallback, control, controlElement, { queue: true });
                        }
                        else {
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (Exit) - Could not set focus to: %s", this.Id, controlName);
                        }
                    }
                    else {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (Exit) - Control element not found to set focus to: %s", this.Id, controlName);
                    }
                }
                else {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->form_setFocus (Exit) - Can not set focus to %s because the form is not active", this.Id, controlName);
                }
            };
            Form.prototype.findControl = function (controlName) {
                var controlElement = $dyn.ui.findControlElement(controlName, this.element);
                if (!controlElement) {
                    // search in the open flyouts associated with this form
                    controlElement = $dyn.ui.findFlyoutControlElement(controlName, this.Id);
                }
                return controlElement;
            };
            /**
             * Set focus to the first control.
             * @internal
             * @param withinMainContainer Whether or not to only search within the main container of the form
             */
            Form.prototype.focusFirstControl = function (withinMainContainer) {
                $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->focusFirstControl (Enter)", this.Id);
                var inEditMode = !$dyn.value(this.IsInViewMode);
                var element = withinMainContainer ? this.element.querySelector(this.element.getAttribute("data-dyn-container")) : this.element;
                var first = $dyn.util.findFirstFocusableControl(element, true, inEditMode, inEditMode);
                if (first) {
                    var control = $dyn.context(first);
                    if (control && control.Root) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->focusFirstControl (Exit) focus control: %s", this.Id, control.Name);
                        control.Root.setControlFocus(control.Name);
                    }
                    else if (control) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->focusFirstControl (Exit) focus control: %s", this.Id, control.Name);
                        this.setControlFocus(control.Name);
                    }
                }
            };
            /**
             * Check if there are any control that has invalid data on the form.
             * @internal
             * @returns Returns true if there are any control that has invalid data; otherwise, false.
             */
            Form.prototype.HasInvalidControls = function () {
                return Object.keys(this.invalidControls).length > 0;
            };
            /**
             * Check if there are any unbound control that has invalid data on the form.
             * @internal
             * @returns Returns true if there are any unbound control that has invalid data; otherwise, false.
             */
            Form.prototype.HasInvalidUnboundControls = function () {
                return Object.keys(this.invalidUnboundControls).length > 0;
            };
            /**
             * Check if there are any control that has invalid data that does not have pending changes.
             * @internal
             * @returns Returns true if there are any control that has invalid data that does not have pending changes; otherwise, false.
             */
            Form.prototype.HasUnchangedInvalidControls = function () {
                return (Object.keys(this.invalidControls).length > 1 ||
                    (Object.keys(this.invalidControls).length === 1 &&
                        (!this.invalidControls[Object.keys(this.invalidControls)[0]].isDisplayedValueDirty
                            || !this.invalidControls[Object.keys(this.invalidControls)[0]].isDisplayedValueDirty())));
            };
            /**
             * Track the list of invalid controls on the form
             * @internal
             * @param invalidControl Control object
             */
            Form.prototype.UpdateInvalidControlList = function (invalidControl) {
                if (invalidControl.IsValid) {
                    if (this.invalidControls[invalidControl.Name]) {
                        if (invalidControl.IsValid()) {
                            delete this.invalidControls[invalidControl.Name];
                            if (this.invalidUnboundControls[invalidControl.Name]) {
                                delete this.invalidUnboundControls[invalidControl.Name];
                            }
                            // Control is no longer invalid. Remove the subscription to the Form's serialize event.
                            if (invalidControl.transitStateSubscriptionId) {
                                this.serializeTransitState.unsubscribe(invalidControl.transitStateSubscriptionId);
                                invalidControl.transitStateSubscriptionId = null;
                            }
                        }
                    }
                    else {
                        if (!invalidControl.IsValid()) {
                            if (!invalidControl.ServiceBoundary || !$dyn.value(invalidControl.ServiceBoundary)) {
                                this.invalidUnboundControls[invalidControl.Name] = invalidControl;
                            }
                            this.invalidControls[invalidControl.Name] = invalidControl;
                            // Control is now invalid. Subscribe to the form's serialize event.
                            if (invalidControl.onSerializeTransitState && !invalidControl.transitStateSubscriptionId) {
                                // Only subscribe if we have the defined handler function AND we do not currently have a subscriptionId to our form's event.
                                invalidControl.transitStateSubscriptionId = this.serializeTransitState.subscribe(invalidControl.onSerializeTransitState.bind(invalidControl));
                            }
                        }
                    }
                }
            };
            /**
             * Sets Focus to the first focusable control that has invalid data.
             * @internal
             * @param suppressErrorMessage Should suppress error messages
             */
            Form.prototype.SetFocusToInvalidControl = function (suppressErrorMessage) {
                var keys = Object.keys(this.invalidControls);
                // tslint:disable-next-line:prefer-for-of
                for (var currentIndex = 0; currentIndex < keys.length; currentIndex++) {
                    var invalidControl = this.invalidControls[keys[currentIndex]];
                    var showErrorMessage = true;
                    var parentElements = $(invalidControl.element).closest(".listRoot");
                    if (parentElements.length > 0) {
                        var listControl = $dyn.context(parentElements[0]);
                        if (listControl.tryFocus) {
                            // true is passed to update the active cell if doing the focus
                            showErrorMessage = listControl.tryFocus(invalidControl.element, true);
                        }
                    }
                    if (showErrorMessage && !suppressErrorMessage) {
                        this.ActiveControl(invalidControl.Name);
                        $dyn.errorMessageBox({ Text: $dyn.label("BoundaryError") });
                    }
                    return;
                }
                if (!suppressErrorMessage) {
                    $dyn.errorMessageBox({ Text: $dyn.label("BoundaryError"), Label: "BoundaryError" });
                }
                $dyn.log.focus && $dyn.log.focus.error && $dyn.log.focus.error("SetFocusToInvalidControl - no invalid controls could be focused, focused control is invalid");
            };
            /**
             * Check if the form is ready to be saved.
             * @internal
             *
             * @param successCallback After all pending server interactions are resolved, if form has no invalid controls, successCallback will be called
             * @param failCallback If there are invalid controls, focus will be set to invalid control, error lightbox will be presented, and the failCallback will be called.
             * @param activeElementInFastEditGrid Active element in fast edit grid. If provided, will suppress error messages.
             */
            Form.prototype.AllowSave = function (successCallback, failCallback, activeElementInFastEditGrid) {
                var _this = this;
                var callback = function () {
                    if (_this.HasInvalidControls()) {
                        _this.SetFocusToInvalidControl(activeElementInFastEditGrid);
                        $dyn.applyFunction(failCallback, _this);
                    }
                    else {
                        $dyn.applyFunction(successCallback, _this);
                    }
                };
                // if there is any pending process we need to wait for processing to complete
                // SetValue commands are assumed to not be throttled (except checkbox which can not be invalid)
                if ($dyn.util.waitForClientBusy()) {
                    $dyn.shell.blockUserInteractionNoWait("Allow save");
                    var subscriberId_3 = $dyn.clientBusy.valueChanged.subscribe(function (value) {
                        if (!$dyn.value(value)) {
                            $dyn.shell.unBlockUserInteraction();
                            // stop observing
                            $dyn.clientBusy.valueChanged.unsubscribe(subscriberId_3);
                            callback();
                        }
                    });
                }
                else {
                    callback();
                }
            };
            /**
             * Removes client form artifacts.
             * @description Do not call directly, use Close to start the form close sequence.
             * @internal
             */
            Form.prototype._close = function () {
                // If a close callback has been set on this form, call it to notify it that the form has closed
                if (this.closeCallback) {
                    $dyn.getFunction(this.closeCallback)();
                }
            };
            Form.prototype.IsCloseRequested = function () {
                return this._isCloseRequested;
            };
            // pulling the callRequestClose out allows popups to modify just this part of the .Close logic
            Form.prototype.callRequestClose = function (requestCloseCallback, record) {
                this._isCloseRequested = true;
                $dyn.callFunction(this.RequestClose, this, [false], requestCloseCallback);
            };
            Form.prototype.dispose = function () {
                this._sidePanel && this.SidePanel.TabbingHandlerDispose();
                this._factBoxPane && this.FactBoxPane.TabbingHandlerDispose();
                if (this.readyStatePromise && this.readyStatePromise.reject) {
                    this.readyStatePromise.reject();
                }
                if (this.UseReactGrid && this.UseReactGrid.valueChanged) {
                    this.UseReactGrid.valueChanged.clearAllDependencies();
                }
                if (this.serializeTransitState && this.serializeTransitState.clear) {
                    this.serializeTransitState.clear();
                }
                if (this.onClose && this.onClose.clear) {
                    this.onClose.clear();
                }
                if (this._formZoomModeWidthObserver) {
                    this._formZoomModeWidthObserver.dispose();
                    this._formZoomModeWidthObserver = undefined;
                }
                if (this._formZoomModeHeightObserver) {
                    this._formZoomModeHeightObserver.dispose();
                    this._formZoomModeHeightObserver = undefined;
                }
                _super.prototype.dispose.call(this);
                if (this._formParts) {
                    this._formParts = [];
                }
            };
            /** @internal */
            Form.prototype.goToNavigationSearch = function () {
                if ($dyn.debug.combinedSearch) {
                    this.goToSearchField(".combinedSearch-navigation", 1);
                }
                else {
                    var navSearch = $dyn.context($("#NavigationSearch")[0]);
                    if (navSearch) {
                        var callTakeNavigationFocus = false;
                        if ($dyn.value(navSearch.SearchFieldVisible)) {
                            callTakeNavigationFocus = true;
                        }
                        navSearch.click();
                        if (callTakeNavigationFocus) {
                            // Need to use navigation focus because d365 nav bar is outside of the form
                            this.takeNavigationFocus();
                        }
                    }
                }
            };
            Form.prototype.executeDefaultActionOrDefaultButton = function (evt) {
                // DefaultAction specified on a form will take precedence on DefaultButton.
                if ($dyn.value(this.DefaultActionEnabled)) {
                    this.ExecuteDefaultAction(evt);
                }
                else {
                    this.executeShortcuts(false, "InvokeDefaultButton", evt);
                }
            };
            Form.prototype.ObserveFactBoxes = function () {
                var _this = this;
                this._childFactBoxObserver = $dyn.observe($dyn.options(function () {
                    var children = [];
                    if (_this.element) {
                        children = $dyn.children(_this.element);
                    }
                    return { Children: children };
                }, this.Updating), function (options) {
                    var childrenElements = options.Children;
                    var _loop_1 = function (i, len) {
                        var child = childrenElements[i];
                        if (child.getAttribute("data-dyn-role") === "FactBox") {
                            var factBox = $dyn.context(child);
                            if (factBox) {
                                if ($dyn.value(factBox.Visible)) {
                                    // Only if the FactBox is visible do we want to set NoShowableFactBoxes to false.
                                    _this.NoShowableFactBoxes(false);
                                    if (_this._childFactBoxObserver) {
                                        _this._childFactBoxObserver.dispose();
                                        _this._childFactBoxObserver = null;
                                    }
                                    return { value: void 0 };
                                }
                                else {
                                    var factBoxWrapper_1 = {
                                        factBox: factBox,
                                    };
                                    // Set up an observer to observe this FactBoxes Visible property in case it ever becomes visible.
                                    factBoxWrapper_1.observer = $dyn.observe(factBoxWrapper_1.factBox.Visible, function (visible) {
                                        visible = $dyn.value(visible);
                                        if (visible) {
                                            _this.NoShowableFactBoxes(false);
                                            if (factBoxWrapper_1.observer) {
                                                factBoxWrapper_1.observer.dispose();
                                                factBoxWrapper_1.observer = null;
                                            }
                                            if (_this._childFactBoxObserver) {
                                                _this._childFactBoxObserver.dispose();
                                                _this._childFactBoxObserver = null;
                                            }
                                        }
                                    });
                                }
                            }
                            else {
                                // this is a client form that has its factboxes
                                // loaded as part of the template
                                // delay the observers created until after the form is loaded
                                _this.DelayedFactBoxLoad = true;
                                return { value: void 0 };
                            }
                        }
                    };
                    for (var i = 0, len = childrenElements.length; i < len; i++) {
                        var state_1 = _loop_1(i, len);
                        if (typeof state_1 === "object")
                            return state_1.value;
                    }
                });
            };
            /**
             * Function checks if in zoom mode and if we are moves filter, list and realted buttons to app bar
             * else it moves them back to their original location
             * @param inZoom is this in zoomed mode
             */
            Form.prototype._adjustBodyElementsForZoom = function (inZoom) {
                if (inZoom && this._zoomElementsMoved === false) {
                    // get appbar
                    var appBar = $(this.element).find("[data-dyn-role='AppBarSection']")[0];
                    var appBarContext = $dyn.context(appBar);
                    if (appBarContext) {
                        var moveElement = $(this.element).find(".button_showFilters")[0];
                        appBarContext.addHostedButton(moveElement);
                        moveElement = $(this.element).find(".button_showList")[0];
                        appBarContext.addHostedButton(moveElement);
                        moveElement = $(this.element).find(".factBoxPane-toggleButton")[0];
                        appBarContext.addHostedButton(moveElement);
                        this._zoomElementsMoved = true;
                    }
                }
                else if (!inZoom && this._zoomElementsMoved === true) {
                    var moveElement = $(this.element).find(".button_showFilters")[0];
                    var destElement = $(this.element).find(".rootLevelSystemDefinedButtons")[0];
                    if (moveElement && destElement) {
                        destElement.appendChild(moveElement);
                    }
                    moveElement = $(this.element).find(".button_showList")[0];
                    if (moveElement && destElement) {
                        destElement.appendChild(moveElement);
                    }
                    destElement = $(this.element).find(".factbox-pane")[0];
                    moveElement = $(this.element).find(".factBoxPane-toggleButton")[0];
                    if (moveElement && destElement) {
                        destElement.parentNode.insertBefore(moveElement, destElement);
                    }
                    this._zoomElementsMoved = false;
                }
            };
            Form.prototype.LocalRefresh = function (refresh) {
                if ($dyn.value(refresh)) {
                    // Refreshing observable is acting as an event trigger, toggle to notify observers to update their data.
                    this.Refreshing(true);
                    this.Refreshing._current = false;
                }
                if ($dyn.isObservable(this.TriggerLocalRefresh)) {
                    this.TriggerLocalRefresh._current = false;
                }
            };
            /**
             * Fired when host should save its form parts personalizations
             * @internal
             * @param newUnsavedViewChanges 1 if we need to save
             */
            Form.prototype.ProcessSaveLinkedViews = function (newUnsavedViewChanges) {
                // only on change from dirty to saved
                if (newUnsavedViewChanges === 1) {
                    if (!this.pendingViewSync) {
                        this.pendingViewSync = $dyn.async(this.SyncViewSave.bind(this));
                    }
                }
            };
            /**
             * Used to sync the dirty view state to the server
             * @internal
             */
            Form.prototype.SetDirtyLinkedViewState = function () {
                $dyn.callFunction(this.LinkedViewDirty, this, [1]);
                this.pendingViewDirtySync = undefined;
            };
            /**
             * Used to sync the dirty view state to the server
             * @internal
             */
            Form.prototype.ClearDirtyLinkedViewState = function () {
                $dyn.callFunction(this.LinkedViewDirty, this, [0]);
                this.pendingViewDirtySync = undefined;
            };
            /**
             * Save the form parts views
             * @internal
             */
            Form.prototype.SyncViewSave = function () {
                var partsCount = this._formParts.length;
                for (var i = 0; i < partsCount; i++) {
                    $dyn.callFunction(this._formParts[i].PersistFormPartViewChanges, this._formParts[i], [$dyn.value(this.CurrentViewKey)]);
                }
                this.pendingViewSync = undefined;
                if ($dyn.value(this.SaveLinkedViews) === 1) {
                    $dyn.async(this.ClearDirtyLinkedViewState.bind(this));
                }
            };
            /**
             * Gets if the form is the activeForm as well as if it has multiple references in the browser history
             * @internal
             *
             * @returns true if the form is the activeForm as well as if it has multiple references in the browser history. Otherwise false.
             */
            Form.prototype.hasMultipleNavigationEntries = function () {
                return this.isNavigationActiveForm() && $dyn.shell.browserHistory.activeFormHasMultipleReferences();
            };
            /**
             * Dynamically adjust the qtip for action search
             * - Can go from the icon to the search field and back (via SearchFieldShown)
             * - Can go from the search field to the result list and back (via ShowResultPicker)
             * - Can go from the result list to a different spot in the result list (via ResultList)
             * @internal
             * @param option options object
             * @returns options object
             */
            Form.prototype.getTaskGuideParamsActionSearch = function (options) {
                // Unblock rails mode so we can use the flyout
                options.avoidRailsModeBlocks = true;
                var appBarSearch = $dyn.context($(this.element).find('[data-dyn-controlname="AppBarSearch"]')[0]);
                // Action search icon
                var targetIcon = $(appBarSearch.element).find(".actionSearch-icon");
                // Action search text field
                var targetField = $(appBarSearch.element).find(".actionSearch-field");
                var observableOptions = $.extend(options, {
                    target: $dyn.observable(targetIcon),
                    // Action search is on the right side of the action pane, so put the qtip on the left
                    my: "right center",
                    at: "left center",
                });
                var showResultPickerSubscription = null;
                // Subscribe to the visibility of the search field changing
                var searchFieldShownSubscription = $dyn.observe(appBarSearch.SearchFieldShown, function (isShown) {
                    if ($dyn.value(isShown)) {
                        observableOptions.target(targetField);
                        // Subscribe to the result list being shown changing
                        var resultListSubscription_1 = null;
                        showResultPickerSubscription = appBarSearch.ShowResultPicker.valueChanged.subscribe(function (resultsShown) {
                            if ($dyn.value(resultsShown)) {
                                // Subscribe to the result list changing
                                resultListSubscription_1 = appBarSearch.ResultList.valueChanged.subscribe(function (resultList) {
                                    var newResultList = $dyn.value(resultList);
                                    if (newResultList.length === 0) {
                                        observableOptions.target(targetField);
                                    }
                                    else {
                                        for (var i = 0; i < newResultList.length; i++) {
                                            if (options.arguments[0] === newResultList[i].Name) {
                                                var targetResult = $($(document)
                                                    .find(".actionSearch-results")
                                                    .children()[i]);
                                                observableOptions.target(targetResult);
                                                break;
                                            }
                                        }
                                    }
                                });
                            }
                            else {
                                // Unsubscribe from ResultList if not showing the results
                                observableOptions.target(targetField);
                                if (resultListSubscription_1) {
                                    appBarSearch.ResultList.valueChanged.unsubscribe(resultListSubscription_1);
                                    resultListSubscription_1 = undefined;
                                }
                            }
                        });
                    }
                    else {
                        // Unsubscribe from ShowResultPicker if not showing the search field
                        observableOptions.target(targetIcon);
                        if (showResultPickerSubscription) {
                            appBarSearch.ShowResultPicker.valueChanged.unsubscribe(showResultPickerSubscription);
                            showResultPickerSubscription = undefined;
                        }
                    }
                });
                $.extend(options, {
                    targetSubscriptions: [searchFieldShownSubscription],
                });
                return options;
            };
            /**
             * Hide/show form root content div
             * @param visible True, to show form root content; otherwise, false
             */
            Form.prototype.SetRootContentVisibility = function (visible) {
                if (visible) {
                    this.element.classList.remove("hide-rootContent");
                }
                else {
                    this.element.classList.add("hide-rootContent");
                }
            };
            Form.prototype.HandleFactBoxPaneOpenClose = function (openFactBox) {
                this.FactBoxPaneCollapsed(!openFactBox);
                this.FactBoxPaneImageName(this.FactBoxPaneCollapsed() ? "OpenPane" : "ClosePane");
                this.FactBoxPaneHelpText(this.FactBoxPaneCollapsed() ? $dyn.label("FactBoxPane_ToggleHelpText") : "");
            };
            Form.prototype.HandleFactBoxPaneFocus = function (doFocus, focusTarget) {
                var _this = this;
                if ($dyn.value(this.FactBoxPaneCollapsed) || focusTarget === $dyn.forms.FactBoxFocusTarget.Form) {
                    var lastSelectedElement = this.ActiveElementInMainFormContainer();
                    if (lastSelectedElement) {
                        this.form_setFocus(lastSelectedElement);
                    }
                }
                else if (doFocus) {
                    var $factBox = $("[data-dyn-role='FactBox']", this.element).first();
                    if ($factBox.length) {
                        var focusableControl_1 = $dyn.util.findFirstTabbableControl($factBox[0]);
                        $dyn.async(function () {
                            _this.InternalFocusIn(focusableControl_1, _this.ActiveElementInMainFormContainer(), true);
                        }, undefined, "async call HandleFactBoxPaneFocus: Async required to handle focus after fact box is completed rendering");
                    }
                }
            };
            /**
             * Move the focus into the combined search field and toggle the selector
             * - If focus is not in the search field, Ctrl+/ will move the focus into the search field and toggle the selection to Pages.
             * - If focus is not in the search field, Ctrl+" will move the focus into the search field and toggle the selection to Actions.
             * - If focus is in the search field, and the selection is Actions, Ctrl+/ will toggle the selection to Pages.
             * - If focus is in the search field, and the selection is Pages, Ctrl+" will toggle the selection to Actions.
             * - For either shortcut, if the selection is in the field, and Pages/Actions is already selected, executing the corresponding shortcut (Pages-Ctrl+/, Actions-Ctrl+") will move the
             * focus back into the last control that was focused on the form outside of the search field.
             *
             * @param searchType Search type
             * @param searchValue Search value
             */
            Form.prototype.goToSearchField = function (searchType, searchValue) {
                var searchElement = $($dyn.ui.getNavBar().element).find(searchType)[0];
                var searchControl = $dyn.context(searchElement);
                var searchToggle = $($dyn.ui.getNavBar().element).find(".combinedSearch")[0];
                var searchToggleControl = $dyn.context(searchToggle);
                if (searchToggleControl) {
                    $dyn.setValue(searchToggleControl, "SelectedSearchType", searchValue);
                }
                this.focusSearchControl(searchControl, searchElement);
            };
            /**
             * Move the focus into the search field or move the focus out of the search field depending on where the current focus is.
             * @param searchControl Search control
             * @param searchElement Search element
             */
            Form.prototype.focusSearchControl = function (searchControl, searchElement) {
                if (searchControl) {
                    if ($dyn.util.isChild(searchElement, this.ActiveElement())) {
                        // Focus is already in the search field. Close the result picker and restore focus outside of the search field.
                        searchControl.closeResultPicker();
                    }
                    else {
                        // Show the field if it is hidden, and set focus to the search field element.
                        if (searchControl.showField) {
                            searchControl.showField();
                        }
                        this.form_setFocus(searchElement, this.ActiveElement());
                    }
                }
            };
            Form.prototype.ActiveElementInMainFormContainerOrSidePanel = function () {
                return this._formOrSidePanelActiveElement;
            };
            /**
             * Check to see the controls cross a service boundary
             * @description There is the service boundary on the control (the data source) and the row index
             * @param toControl Control object
             * @param fromControl Control object
             * @returns True if crossing boundry; otherwise, false.
             */
            Form.prototype.AreControlsCrossBoundary = function (toControl, fromControl) {
                if (!toControl) {
                    return false;
                }
                // if we are coming from no focused control to any focused control we have to assume cross boundary
                if (!fromControl) {
                    return true;
                }
                if ($dyn.value(toControl.ServiceBoundary) !== $dyn.value(fromControl.ServiceBoundary)) {
                    // Relies on (null == undefined) returning true
                    // tslint:disable-next-line:triple-equals
                    if ($dyn.value(fromControl.ServiceBoundary) == undefined || $dyn.value(fromControl.ServiceBoundary) == "") {
                        return false;
                    }
                    return true;
                }
                // if the control have DataSources check the collectionIndex
                var toDataSource = $dyn.value(toControl.DataSource);
                var fromDataSource = $dyn.value(fromControl.DataSource);
                if (toDataSource && fromDataSource) {
                    if (toDataSource.collectionIndex !== fromDataSource.collectionIndex) {
                        if (toDataSource.collectionIndex === undefined) {
                            return false;
                        }
                        else if (fromDataSource.collectionIndex === undefined &&
                            toDataSource.parent &&
                            toDataSource.collectionIndex === $dyn.value(toDataSource.parent.selectedIndex)) {
                            return false;
                        }
                        return true;
                    }
                }
                else if (fromDataSource) {
                    return true;
                }
                return false;
            };
            Form.prototype._getParentListByElement = function (element) {
                if (element) {
                    var gridSelector = $dyn.value(this.UseReactGrid) ? ".react-listRoot" : ".listRoot";
                    var $grid = $(element).closest(gridSelector);
                    if ($grid[0]) {
                        return $dyn.context($grid[0]);
                    }
                    else {
                        var $rowTemplate = $(element).closest(".rowTemplate");
                        if ($rowTemplate[0]) {
                            // Get the id off of the orphaned row template
                            var rowTemplateId = $rowTemplate[0].id;
                            // Get the id off of the orphaned row template
                            var rowId = rowTemplateId.substring(0, rowTemplateId.indexOf("_RowTemplate"));
                            if (!rowId) {
                                rowId = rowTemplateId.substring(0, rowTemplateId.indexOf("_row"));
                            }
                            if (rowId) {
                                return $dyn.context($("#" + rowId)[0]);
                            }
                        }
                    }
                }
            };
            Form.prototype.moveSystemDefinedManageViewFilters = function (location) {
                var locationElement;
                var beforeElement = null;
                var targetClass = null;
                var viewSelectorClass = null;
                var seperatorClass = null;
                if (this && !this.Root) {
                    // First delete the existing classes
                    if (this.SystemDefinedManagedViewFiltersElement.classList.contains("showSeperator")) {
                        this.SystemDefinedManagedViewFiltersElement.classList.remove("showSeperator");
                    }
                    if (this.SystemDefinedManagedViewFiltersElement.classList.contains("largeHeader")) {
                        this.SystemDefinedManagedViewFiltersElement.classList.remove("largeHeader");
                    }
                    if (this.SystemDefinedManagedViewFiltersElement.classList.contains("viewButtonWithEntity")) {
                        this.SystemDefinedManagedViewFiltersElement.classList.remove("viewButtonWithEntity");
                    }
                    if (this.SystemDefinedManagedViewFiltersElement.classList.contains("viewButtonWithContext")) {
                        this.SystemDefinedManagedViewFiltersElement.classList.remove("viewButtonWithContext");
                    }
                    switch (location) {
                        case $dyn.forms.ViewsButtonLocation.MainCaption:
                            targetClass = ".formCaptionContainer";
                            viewSelectorClass = "largeHeader";
                            break;
                        case $dyn.forms.ViewsButtonLocation.TopEntityName:
                            locationElement = $(this.element).find(".formCaptionContainer")[0];
                            beforeElement = $(this.element).find(".formCaption-context")[0];
                            viewSelectorClass = "viewButtonWithEntity";
                            if (locationElement && beforeElement) {
                                locationElement.insertBefore(this.SystemDefinedManagedViewFiltersElement, beforeElement);
                                this.SystemDefinedManagedViewFiltersElement.classList.add(viewSelectorClass);
                            }
                            if ($dyn.value(this.FormCaption()) || $dyn.value(this.ParentTitleFields)) {
                                seperatorClass = "showSeperator";
                            }
                            break;
                        case $dyn.forms.ViewsButtonLocation.TopContext:
                        default:
                            targetClass = ".formCaption-context";
                            viewSelectorClass = "viewButtonWithContext";
                            if ($dyn.value(this.ParentTitleFields)) {
                                seperatorClass = "showSeperator";
                            }
                            break;
                    }
                    // Then add proper classes
                    if (targetClass != null) {
                        locationElement = $(this.element).find(targetClass)[0];
                        if (locationElement) {
                            locationElement.appendChild(this.SystemDefinedManagedViewFiltersElement);
                            this.SystemDefinedManagedViewFiltersElement.classList.add(viewSelectorClass);
                        }
                    }
                    if (seperatorClass != null) {
                        this.SystemDefinedManagedViewFiltersElement.classList.add(seperatorClass);
                    }
                }
            };
            Form.prototype.updateFormHeadingLevel = function () {
                // check for missing h1 tag and Dashboard form
                if ($dyn.value(this.Style) === "Dashboard" && this.element.getElementsByTagName("h1")[0] === undefined) {
                    // see if company name field exists
                    var elementToChange = this.element.querySelector("[data-dyn-controlname=CompanyName]");
                    if (elementToChange) {
                        elementToChange.setAttribute("aria-level", "1");
                        elementToChange.setAttribute("role", "heading");
                    }
                    else {
                        // check if using the formcaption style
                        elementToChange = this.element.querySelector(".formCaption");
                        if (elementToChange) {
                            elementToChange.setAttribute("aria-level", "1");
                            elementToChange.setAttribute("role", "heading");
                        }
                    }
                }
            };
            /**
             * Manages panels (side panel, filter pane and factbox pane) behavior based on viewport size
             * @description
             * On small viewport, opening any of the side panes closes all others
             * Resizing browser to small viewport closes all opened panels.
             * On medium size only one panel can be open and opening one will close previous opened panel
             * On large size two panels can stay open and opening the third panel will close one of the open panels with lower priority
             * On Xlarge size all panels can be open together
             */
            Form.PanelManager = /** @class */ (function () {
                function PanelManagerClass(formThis) {
                    this.formThis = formThis;
                }
                /** Initializes the panel manager */
                PanelManagerClass.prototype.init = function () {
                    var _this = this;
                    this.panels = [];
                    if (this.formThis.FilterPaneControl) {
                        this.panels.push(this.formThis.FilterPaneControl);
                        $dyn.observe(this.formThis.FilterPaneControl.Visible, function (newValue) {
                            _this._panelVisibleHandler(newValue, _this.formThis.FilterPaneControl);
                        }, this, null, true);
                    }
                    if (this.formThis.SidePanel.SidePanelContext) {
                        this.panels.push(this.formThis.SidePanel);
                        $dyn.observe(this.formThis.SidePanel.SidePanelContext.Visible, function (newValue) {
                            _this._panelVisibleHandler(newValue, _this.formThis.SidePanel);
                        }, this, null, true);
                    }
                    if (this.formThis.FactBoxPane.hasFactBox) {
                        this.panels.push(this.formThis.FactBoxPane);
                        $dyn.observe(this.formThis.FactBoxPaneCollapsed, function (newValue) {
                            _this._panelVisibleHandler(!newValue, _this.formThis.FactBoxPane);
                        }, this, null, true);
                        if ($dyn.isObservable(this.formThis.FactBoxPaneInitiallyExpanded)) {
                            $dyn.observe(this.formThis.FactBoxPaneInitiallyExpanded, function (newValue) {
                                _this.formThis.HandleFactBoxPaneOpenClose(newValue);
                                _this.formThis.HandleFactBoxPaneFocus(true);
                            });
                        }
                    }
                    // If form has any panels then start monitoring
                    if (this.panels.length > 0) {
                        if ($dyn.shell.CurrentFormViewportSize === $dyn.shell.ViewportSize.Small) {
                            // close all the open panels in small viewport in the beginning
                            this._panelsResponsiveHandler();
                        }
                        this.viewPortBreakHandler = $dyn.bindingHandlers.FormViewportSize();
                        $dyn.observe(this.formThis.IsActive, function (newValue) {
                            if (newValue) {
                                // Call the handler to do any needed adjustments when form became active
                                _this._viewportChangeHandler(null, $dyn.shell.CurrentFormViewportSize);
                                // Register ViewportSize handler when form is active
                                _this.viewPortBreakHandler.apply(_this._viewportChangeHandler, _this);
                            }
                            else {
                                _this.viewPortBreakHandler.dispose();
                            }
                        });
                    }
                };
                /**
                 * Handles responsiveness of the panels based on current viewport size And closes panels if needed
                 * @param keepOpenPanel Provide the panel to leave open
                 */
                PanelManagerClass.prototype._panelsResponsiveHandler = function (keepOpenPanel) {
                    if (this.panels && this.panels.length > 0) {
                        var totalPanelsAllowed = void 0;
                        var showRootContent = true;
                        if ($dyn.shell.CurrentFormViewportSize === $dyn.shell.ViewportSize.Small) {
                            // If view port is resized to small then no panel can stay open
                            // However, if view port is already small and a panel is opened then we need to hide the form content and keep the opened panel open
                            totalPanelsAllowed = 0;
                            if (keepOpenPanel) {
                                // If a panel need to stay open then we need to hide form content
                                showRootContent = false;
                            }
                        }
                        else if ($dyn.shell.CurrentFormViewportSize === $dyn.shell.ViewportSize.Medium) {
                            // If medium size then one panel can stay open
                            totalPanelsAllowed = 1;
                        }
                        else if ($dyn.shell.CurrentFormViewportSize === $dyn.shell.ViewportSize.Large) {
                            // If large size then two panel can stay open
                            totalPanelsAllowed = 2;
                        }
                        else {
                            // All panels can stay open
                            totalPanelsAllowed = this.panels.length;
                        }
                        this.formThis.SetRootContentVisibility(showRootContent);
                        var panelsToClose = this._getOpenPanelsCount() - totalPanelsAllowed; // number of panels need to be closed
                        var panel = void 0;
                        var i = 0;
                        while (panelsToClose > 0 && i < this.panels.length) {
                            panel = this.panels[i++];
                            if (!keepOpenPanel || keepOpenPanel.Id !== panel.Id) {
                                if ($dyn.callFunction(panel.close, panel)) {
                                    // returns true when panel was actually closed
                                    panelsToClose--;
                                }
                            }
                        }
                    }
                };
                /**
                 * Returns number of open panels
                 * @returns number of open panels
                 */
                PanelManagerClass.prototype._getOpenPanelsCount = function () {
                    var openPanels = 0;
                    this.panels.map(function (panel) {
                        if (panel.isOpen()) {
                            openPanels++;
                        }
                    });
                    return openPanels;
                };
                /**
                 * Handles panels behavior on visibility change
                 * @param isVisible Panel visibility
                 * @param panel Panel object
                 */
                PanelManagerClass.prototype._panelVisibleHandler = function (isVisible, panel) {
                    if (isVisible) {
                        // If a panel is opened then run panels responsive logic
                        this._panelsResponsiveHandler(panel);
                    }
                    else {
                        // If a panel is closed and no other panel is open then show the root content
                        if (this._getOpenPanelsCount() === 0) {
                            this.formThis.SetRootContentVisibility(true);
                        }
                    }
                };
                /**
                 * Handles panels behavior on viewport size change
                 * @param evt Event object
                 * @param currentVpSize Current view port size
                 */
                PanelManagerClass.prototype._viewportChangeHandler = function (evt, currentVpSize) {
                    // If viewport size has changed since last call then run panels responsive logic
                    if (this.lastViewportSize !== currentVpSize) {
                        this._panelsResponsiveHandler();
                        this.lastViewportSize = currentVpSize;
                    }
                };
                return PanelManagerClass;
            }());
            return Form;
        }($dyn.ui.Container));
        controls.Form = Form;
        Form.prototype.IsForm = true;
        Form.prototype.MenuItemName = "";
        Form.prototype.elementToFocus = null;
        Form.prototype.elementToFocusName = "";
        Form.prototype.isSetControlFocusCalled = false;
        Form.prototype.TypeName = "Form";
        Form.prototype.RequestCloseCommandName = "RequestClose";
        Form.prototype.IsTabbingContainer = true;
        Form.prototype.disposeOnClose = true;
        Form.prototype.Width = $dyn.layout.Size.available;
        Form.prototype.Height = $dyn.layout.Size.available;
        // tslint:disable-next-line:no-string-literal
        Form.prototype["systemDefinedManagedViewFiltersElementDetailsMasterMoved"] = false;
        // tslint:disable-next-line:no-string-literal
        Form.prototype["_isCloseRequested"] = false;
        // Notes:
        // 1. Please update corresponding server side helptext labels for system defined buttons if you are changing those shortcuts defined below.
        // 2. Keep the list of shortcuts in alphabetical order.
        var FormShortcuts = __assign(__assign(__assign(__assign({ AdvancedFilterSort: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.f3 },
                Handler: function (evt) {
                    this.executeShortcuts(true, "AdvancedFilterSort", evt);
                },
                Description: $dyn.label("Form_OpenAdvancedSort"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, AltSave: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterS },
                Handler: function (evt) {
                    this.executeShortcuts(true, "SaveRecord", evt);
                },
                Description: $dyn.label("Form_SaveRecord"),
                Category: $dyn.ui.ShortcutCategory.ActOnData,
            }, Attach: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterA },
                Handler: function (evt) {
                    if ($dyn.value(this.Style) !== "Dashboard" && $dyn.value(this.Style) !== "Workspace") {
                        this.executeShortcuts(true, "AttachRecord", evt);
                        return true;
                    }
                    return false;
                },
                Description: $dyn.label("Form_AttachDocument"),
                ShowToUser: function () {
                    return $dyn.value(this.Style) !== "Dashboard" && $dyn.value(this.Style) !== "Workspace";
                },
            }, DefaultAction: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    this.ExecuteDefaultAction(evt);
                },
                ShowToUser: false,
            }, DefaultActionAlternate: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    this.ExecuteDefaultAction(evt);
                },
                ShowToUser: function () {
                    return $dyn.value(this.DefaultActionEnabled) && !!$dyn.value(this.DefaultAction);
                },
                Description: $dyn.label("Form_DefaultAction"),
            }, Delete: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.deleteKey },
                Handler: function (evt) {
                    this.executeShortcuts(false, "DeleteRecord", evt);
                },
                Description: $dyn.label("Form_DeleteRecord"),
                Category: $dyn.ui.ShortcutCategory.ActOnData,
            }, DeleteF9: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.f9 },
                Handler: function (evt) {
                    this.executeShortcuts(false, "DeleteRecord", evt);
                },
                ShowToUser: false,
            }, DetailsView: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterD },
                Handler: function (evt) {
                    this.executeShortcuts(true, "DetailsView", evt);
                },
                Description: $dyn.label("Form_DetailsView"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, Escape: {
                Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function (evt) {
                    if (!$dyn.isEmbedded || ($dyn.isEmbedded && $dyn.length($dyn.shell.stack) > 1)) {
                        this.escape(evt);
                    }
                },
                Description: $dyn.label("Form_Close"),
                Category: $dyn.ui.ShortcutCategory.Close,
            }, ExportToExcel: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterE },
                Handler: function (evt) {
                    this.executeShortcuts(true, "ExportToExcel", evt);
                },
                Description: $dyn.label("Form_ExportExcel"),
            }, FactBoxPane: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.f2 },
                Handler: function (evt) {
                    this.ToggleFactBoxPane(evt, $dyn.forms.FactBoxFocusTarget.FactBox);
                },
                ShowToUser: false,
            }, FactBoxPaneAlt: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterB },
                Handler: function (evt) {
                    if ($dyn.value(this.FactBoxPaneCollapsed)) {
                        this.ToggleFactBoxPane(evt, $dyn.forms.FactBoxFocusTarget.FactBox);
                    }
                    else {
                        var $factBox = $("[data-dyn-role='FactBox']", this.element).first();
                        if ($factBox.length) {
                            var focusableControl = $dyn.util.findFirstTabbableControl($factBox[0]);
                            this.form_setFocus(focusableControl, true);
                        }
                    }
                },
                Description: $dyn.label("Form_GoToFactBoxPane"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, FirstRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.home },
                Handler: function (evt) {
                    this.executeShortcuts(true, "FirstRecord", evt);
                },
                Description: $dyn.label("Form_FirstRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, ForceClose: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterQ },
                Handler: function (evt) {
                    if (!$dyn.isEmbedded || ($dyn.isEmbedded && $dyn.length($dyn.shell.stack) > 1)) {
                        this.executeShortcuts(false, "ForceClose");
                    }
                },
                Description: $dyn.label("Form_ForceClose"),
                Category: $dyn.ui.ShortcutCategory.Close,
            }, 
            // TODO: Not all forms have appbars (dialogs, ligtboxes, dashboard)
            GoToActionPane: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.f6 },
                Handler: function (evt) {
                    if ($(this.ActiveElement()).parents(".appBar").length === 0) {
                        var activeElement = $dyn.util.findFirstFocusableControl($(this.element)
                            .find("[data-dyn-role='AppBarSection']:visible")
                            .first()[0], false);
                        // set to true for InternalFocusIn to set to Tab containers if present and first focusable element.
                        this.InternalFocusIn(activeElement, this.ActiveElement(), true);
                    }
                    else {
                        this.RestoreFocusToMainFormContainer();
                    }
                },
                ShowToUser: false,
            }, GoToActionPaneAlt: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterA },
                Handler: function (evt) {
                    if ($(this.ActiveElement()).parents(".appBar").length === 0) {
                        var activeElement = $dyn.util.findFirstFocusableControl($(this.element)
                            .find("[data-dyn-role='AppBarSection']:visible")
                            .first(), false);
                        // set to true for InternalFocusIn to set to Tab containers if present and first focusable element.
                        this.InternalFocusIn(activeElement, this.ActiveElement(), true);
                    }
                },
                Description: $dyn.label("Form_GoToActionPane"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, GoToActionSearchField: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.apostrophe },
                Handler: function (evt) {
                    this.goToActionSearch();
                },
                ShowToUser: false,
            }, 
            // TODO: may not have an action search field
            GoToActionSearchFieldAlt: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterQ },
                Handler: function (evt) {
                    this.goToActionSearch();
                },
                Description: $dyn.label("Form_GoToActionSearch"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, GoToFilterPane: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.f3 },
                Handler: function (evt) {
                    var filterPane = this.FilterPaneControl;
                    if (filterPane) {
                        if ($dyn.value(filterPane.Visible)) {
                            // If the FilterPane is already visible, toggle focus between the FilterPane and the form.
                            var newActiveElement = void 0;
                            if ($(this.ActiveElement()).parents(".filterPane").length === 0) {
                                if (filterPane.element) {
                                    newActiveElement = $dyn.util.findFirstFocusableControl(filterPane.element);
                                }
                                this.InternalFocusIn(newActiveElement, this.ActiveElement());
                            }
                            else {
                                this.RestoreFocusToMainFormContainer();
                            }
                        }
                        else {
                            // If the FilterPane is not visible yet, show it
                            if (filterPane.toggleVisibility) {
                                filterPane.toggleVisibility();
                            }
                        }
                    }
                },
                ShowToUser: false,
            }, GoToFilterPaneAlt: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterF },
                Handler: function (evt) {
                    var filterPane = this.FilterPaneControl;
                    if (filterPane) {
                        if ($dyn.value(filterPane.Visible)) {
                            // If the FilterPane is already visible, toggle focus between the FilterPane and the form.
                            var newActiveElement = void 0;
                            if ($(this.ActiveElement()).parents(".filterPane").length === 0) {
                                if (filterPane.element) {
                                    newActiveElement = $dyn.util.findFirstFocusableControl(filterPane.element);
                                }
                                this.InternalFocusIn(newActiveElement, this.ActiveElement());
                            }
                        }
                        else {
                            // If the FilterPane is not visible yet, show it
                            if (filterPane.toggleVisibility) {
                                filterPane.toggleVisibility();
                            }
                        }
                    }
                },
                ShowToUser: function () {
                    return this.FilterPaneControl ? true : false;
                },
                Description: $dyn.label("Form_GoToFilterPane"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, GoToFirstFormVisibleField: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterF },
                Handler: function (evt) {
                    // Restore focus to first visible field in the main form content has the rootContent class.
                    this.RestoreFocusToMainFormFirstVisibleControl();
                },
                Description: $dyn.label("Form_GoToFirstVisible"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, GoToMessageBar: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.f7 },
                Handler: function (evt) {
                    // set focus to the message bar
                    if (this.MessageBar && $dyn.value(this.MessageBar.IsVisible)) {
                        this.MessageBar.shortcutFocus();
                    }
                },
                ShowToUser: function () {
                    return this.MessageBar && $dyn.value(this.MessageBar.IsVisible);
                },
                Description: $dyn.label("Form_GoToMessageBar"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            } }, !$dyn.isEmbedded && {
            GoToNavigationList: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.f8 },
                Handler: function (evt) {
                    // If Navigation List (SidePanel) is visible and has focus, pressing this shortcut will switch focus to the last selected control within the form.
                    // Otherwise switch focus to the first focusable control within the SidePanel.
                    var sidePanelElement = this.SidePanel.SidePanelElement;
                    if (sidePanelElement && $dyn.value(this.SidePanel.SidePanelContext.Visible)) {
                        var newActiveElement = void 0;
                        if ($(evt.target)
                            .parents()
                            .is(".SidePanel")) {
                            this.RestoreFocusToMainFormContainer();
                        }
                        else {
                            newActiveElement = $dyn.util.findFirstFocusableControl(sidePanelElement);
                            this.InternalFocusIn(newActiveElement, this.ActiveElement());
                        }
                    }
                    else {
                        // If SidePanel is not visible then open it by clicking the ShowList button.
                        $dyn.callFunction(this.SidePanel.toggleVisibility, this);
                    }
                },
                ShowToUser: false,
            },
            GoToNavigationListAlt: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterS },
                Handler: function (evt) {
                    // If Navigation List (SidePanel) is visible and has focus, pressing this shortcut will switch focus to the last selected control within the form.
                    // Otherwise switch focus to the first focusable control within the SidePanel.
                    var sidePanelElement = this.SidePanel.SidePanelElement;
                    if (sidePanelElement && $dyn.value(this.SidePanel.SidePanelContext.Visible)) {
                        if (!$(evt.target)
                            .parents()
                            .is(".SidePanel")) {
                            var newActiveElement = $dyn.util.findFirstFocusableControl(sidePanelElement);
                            this.InternalFocusIn(newActiveElement, this.ActiveElement());
                        }
                    }
                    else {
                        // If SidePanel is not visible then open it by clicking the ShowList button.
                        $dyn.callFunction(this.SidePanel.toggleVisibility, this);
                    }
                },
                ShowToUser: function () {
                    return this.SidePanel ? true : false;
                },
                Description: $dyn.label("Form_GoToNavList"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            GoToNavigationSearch_Primary: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.forwardslash },
                Handler: function () {
                    this.goToNavigationSearch();
                },
                ShowToUser: false,
            },
            // TODO: will every form have a navigation search? Should this be a shell command?
            GoToNavigationSearch_Alternate: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterG },
                Handler: function () {
                    this.goToNavigationSearch();
                },
                Description: $dyn.label("Form_GoToNavSearch"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
        }), { GridView: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterG },
                Handler: function (evt) {
                    this.executeShortcuts(true, "GridView", evt);
                },
                Description: $dyn.label("Form_GridView"),
            }, HeaderView: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterH },
                Handler: function (evt) {
                    this.executeShortcuts(true, "HeaderView", evt);
                },
                Description: $dyn.label("Form_HeaderView"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, LastRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.end },
                Handler: function (evt) {
                    this.executeShortcuts(true, "LastRecord", evt);
                },
                Description: $dyn.label("Form_LastRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, LinesView: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterL },
                Handler: function (evt) {
                    this.executeShortcuts(true, "LinesView", evt);
                },
                Description: $dyn.label("Form_LinesView"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, New: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterN },
                Handler: function (evt) {
                    this.executeShortcuts(true, "NewRecord", evt);
                },
                Description: $dyn.label("Form_NewRecord"),
                Category: $dyn.ui.ShortcutCategory.ActOnData,
            }, NextRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function (evt) {
                    this.executeShortcuts(true, "NextRecord", evt);
                },
                Description: $dyn.label("Form_NextRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, PageSelect: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.letterA },
                Handler: function (evt) {
                    if ($dyn.value(this.UseReactGrid) && evt && evt.target) {
                        var isWithinReactGrid = $(evt.target)
                            .parents()
                            .hasClass("reactGrid");
                        return !isWithinReactGrid;
                    }
                    return true;
                },
                ShowToUser: false,
            } }), !$dyn.isEmbedded && {
            Personalize: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterP },
                Handler: function (evt) {
                    this.personalize();
                },
                ShowToUser: function () {
                    return $dyn.value(this.AllowExplicitPersonalization);
                },
                Description: $dyn.label("Form_Personalize"),
            },
        }), { PreviousRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function (evt) {
                    this.executeShortcuts(true, "PreviousRecord", evt);
                },
                Description: $dyn.label("Form_PrevRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            }, Refresh: {
                Keys: { shift: true, keyCode: $dyn.ui.KeyCodes.f5 },
                Handler: function (evt) {
                    this.executeShortcuts(true, "Refresh", evt);
                },
                Description: $dyn.label("Form_Refresh"),
            }, RequestClose: {
                Keys: { shift: true, keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function (evt) {
                    this.EscapeSaveYes();
                },
                Description: $dyn.label("Form_RequestClose"),
                Category: $dyn.ui.ShortcutCategory.Close,
            }, Restore: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.f5 },
                Handler: function (evt) {
                    this.executeShortcuts(false, "Restore", evt);
                },
                Description: $dyn.label("Form_Revert"),
            }, Save: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.letterS },
                Handler: function (evt) {
                    this.executeShortcuts(true, "SaveRecord", evt);
                },
                ShowToUser: false,
            }, SelectAll: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Handler: function (evt) {
                    this.executeShortcuts(true, "SelectAll", evt);
                },
                Description: $dyn.label("Form_SelectAll"),
            }, ViewEdit: {
                Keys: { keyCode: $dyn.ui.KeyCodes.f2 },
                Handler: function (evt) {
                    this.executeShortcuts(true, "ViewEdit", evt);
                },
                Description: function () {
                    return $dyn.value(this.IsInViewMode) ? $dyn.label("Form_EditMode") : $dyn.label("Form_ViewMode");
                },
            } });
        Form.prototype.Shortcuts = $dyn.extendPrototype(Form.prototype.Shortcuts, FormShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Form.js.map
